// 教务中心api
import request from "@/config/_request";
import qs from "qs";

const postRestArgs = (params, admin = true) => ({
  data: params,
  method: "post",
  headers: {
    "Content-Type": "application/json"
  },
  admin,
})

/**
 * 增加校区
 * @param {*} params 
 * @returns 
 */
export function addEducationalInstitutionCampus(params) {
  return request({
    url: "/java-api/school/edu/campus/create",
    ...postRestArgs(params, false)
  });
}


// 获取校区
export function getEducationalInstitutionCampusList(params) {
  return request({
    url: "/api/get/educational_institution_campus/list",
    params,
    method: "get",
  });
}

// 修改校区名称
export function editEducationalInstitutionCampusName(params) {
  return request({
    url: "/api/update/educational_institution_campus",
    data: qs.stringify(params),
    method: "post",
  });
}

// 删除校区
export function deleteEducationalInstitutionCampus(params) {
  return request({
    url: "/api/delete/educational_institution_campus",
    data: qs.stringify(params),
    method: "post",
  });
}

// 获取基础信息
export function getBaseInfo(params) {
  return request({
    url: "/api/get/educational_institution_info",
    params,
    method: "get",
  });
}

// 添加停课日
export function addStopDay(params) {
  return request({
    url: "/api/add/educational_institution_closing_day",
    data: qs.stringify(params),
    method: "post",
  });
}

// 添加学校授课时段
export function addClassDay(params) {
  return request({
    url: "/api/add/educational_institution_class_day",
    data: qs.stringify(params),
    method: "post",
  });
}

// 设置学校的家长手机号是否加密显示接口
export function updateIsEncryption(params) {
  return request({
    url: "/api/update/educational_institution/is_encryption",
    data: qs.stringify(params),
    method: "post",
  });
}

//查询班级信息
export function getClasses(params) {
  return request({
    url: "/api/get/classes",
    params,
    method: "get",
  });
}

// 查询班级列表接口
export function getClassesList(params) {
  return request({
    url: "/api/get/classes/list",
    params,
    method: "get",
  });
}
// 添加班级
export function addClass(params) {
  return request({
    url: "/api/add/classes",
    data: qs.stringify(params),
    method: "post",
  });
}

export function addClasses(params) {
  return request({
    url: "/api/add/classes",
    data: qs.stringify(params),
    method: "post",
  });
}
export function addClassAll(params) {
  return request({
    url: "/api/add/class/and/tch/plan",
    data: qs.stringify(params),
    method: "post",
  });
}


// 查询符合课程体系的用户（主讲教师、助教老师）
export function getCurriculumPermissionList(params) {
  return request({
    url: "/api/get/curriculum_permission/list",
    params,
    method: "get",
  });
}

// 添加科目
export function addSubject(params, admin) {
  return request({
    url: "/api/add/subject",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}

// 更新科目
export function updateSubject(params, admin) {
  return request({
    url: "/api/update/subject",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}

// 删除科目
export function deleteSubject(params, admin) {
  return request({
    url: "/api/delete/subject",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}

// 添加课程体系
export function addCurriculum(params, admin) {
  return request({
    url: "/api/add/curriculum",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}

// 获取课程列表
export function getCurriculumList(params, admin) {
  return request({
    url: "/api/get/curriculum/list",
    params,
    method: "get",
    admin
  });
}

// 获取课程体系
export function getCurriculumInfo(params, admin) {
  return request({
    url: "/api/get/curriculum",
    params,
    method: "get",
    admin: admin
  });
}

// 删除课程体系
export function deleteCurriculum(params, admin) {
  return request({
    url: "/api/delete/curriculum",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}


export function deleteSchoolCurriculum(params) {
  return request({
    url: "/api/delete/curriculum",
    data: qs.stringify(params),
    method: "post"
  });
}




// 设置课程体系停用/发布接口
export function updateCurriculumState(params, admin) {
  return request({
    url: "/api/update/curriculum/state",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}
// 设置课程体系设置有效无效
export function updateCurriculumEffective(params, admin) {
  return request({
    url: "/api/updateCurriculumEffective",
    data: qs.stringify(params),
    method: "post",
    admin
  });
}

// 编辑课程体系-旧
export function updateCurriculumInfo(params, admin) {
  return request({
    url: "/api/update/curriculum",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}


// 编辑课程体系
export function addOrUpdateCurriculumMaterial(params, admin) {
  return request({
    url: "/api/admin/addOrUpdate/curriculumMaterial",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}

// 删除课程体系
export function deleteCurriculumMaterial(params, admin) {
  return request({
    url: "/api/admin/delete/curriculumMaterial",
    data: qs.stringify(params),
    method: "post",
    admin: admin
  });
}


// 删除班级
// export function deleteClasses(params) {
//   return request({
//     url: "/api/delete/classes",
//     data: qs.stringify(params),
//     method: "post",
//   });
// }
export function deleteClasses(params) {
  return request({
    url: "/api/delete/classes/without/limit",
    data: qs.stringify(params),
    method: "post",
  });
}

// 获取班级信息
export function getClassInfo(params) {
  return request({
    url: "/api/get/classes",
    params,
    method: "get",
  });
}

// 更新班级
export function updateClasses(params) {
  return request({
    url: "/api/update/classes",
    data: qs.stringify(params),
    method: "post",
  });
}

// 新建学员接口
export function entertStudent(params) {
  return request({
    url: "/api/add/student",
    data: qs.stringify(params),
    method: "post",
  });
}

// 获取学校下所有老师
export function getUserTeacher(params) {
  return request({
    url: "/api/get/educational_institutio/user/list",
    params,
    method: "get",
  });
}

// 获取学员列表
export function getStudentList(params) {
  return request({
    url: "/api/get/student/list",
    params,
    method: "get",
  });
}

// 获取学员详情
export function getStudentDetail(params) {
  return request({
    url: "/api/get/student",
    params,
    method: "get",
  });
}

// 编辑学员
export function updateStudentDetail(params) {
  return request({
    url: "/api/update/student",
    data: qs.stringify(params),
    method: "post",
  });
}

// 排课
export function addTeachingPlan(params) {
  return request({
    url: "/api/add/teaching/plan",
    data: qs.stringify(params),
    method: "post",
  });
}

// 根据班级id查询教学计划接口
export function getPlan(params) {
  return request({
    url: "/api/get/teaching/plan/by/class/id",
    params,
    method: "get",
  });
}

// 教学计划更新教师
export function updatePlanTeacher(params) {
  return request({
    url: "/api/update/teaching/plan/lecturer",
    data: qs.stringify(params),
    method: "post",
  });
}

// 教学计划更新上课时间
export function updatePlanTime(params) {
  return request({
    url: "/api/update/teaching/plan/by/time",
    data: qs.stringify(params),
    method: "post",
  });
}


// 获取备授课每节课列表和每节课课程地址
export function getPrepareTeachPlan(params) {
  return request({
    url: "/api/get/prepare/for/teaching/plan",
    params,
    method: "get",
  });
}

// 添加学生签到
export function updateStudentSign(params) {
  return request({
    url: "/api/get/prepare/for/student/sign",
    data: qs.stringify(params),
    method: "post",
    noLoading: true
  });
}


// 备课中心
// 获取签到的学生列表
export function getPrepareCurrculumList(params) {
  return request({
    url: "/api/prepare/get/currculumlist",
    params,
    method: "get",
  });
}

//获取课程体系对应的课程列表

export function getPrepareCurrculumMaterialList(params) {
  return request({
    url: "/api/prepare/get/currculumMaterialList",
    params,
    method: "get",
  });
}


/**
 * 获取课程体系对应的课程列表
 * @param {*} params 
 * @returns 
 */
export function getPrepareCurrculumMaterial(params) {
  return request({
    url: "/java-api/school/currMat/detail",
    ...postRestArgs(params, false)
  });
}

// 添加学生签到
export function addPrepareForStudentSign(params) {
  return request({
    url: "/api/get/prepare/for/student/sign",
    data: qs.stringify(params),
    method: "post",
    //noLoading: true
  });
}

//招生管理
//获取所有无班级学员列表
export function getNoClassStudentList(params) {
  return request({
    url: "/api/get/no/class/student/list",
    params,
    method: "get",
  });
}

//录入无班级学员
export function addNoClassStudent(params) {
  return request({
    url: "/api/add/no/class/student",
    data: qs.stringify(params),
    method: "post",
  });
}

//获得所有试听班级
export function getAuditionClassesList(params) {
  return request({
    url: "/api/get/audition/classes/list",
    params,
    method: "get",
  });
}

//添加商品
export function addOrUpdateOtherGoods(params) {
  return request({
    url: "/api/addOrUpdate/other/goods",
    data: qs.stringify(params),
    method: "post",
  });
}

//获取商品列表
export function getGoodsList(params) {
  return request({
    url: "/api/get/goods/list",
    params,
    method: "get",
  });
}

//招生管理-无班级学员转为试听学员

export function addNoClassStudentToAuditionClassForAudition(params) {
  return request({
    url: "/api/add/no/class/student/to/audition/class/for/audition",
    data: qs.stringify(params),
    method: "post",
  });
}

//无班级学员转为正式学员
export function addNoClassStudentToNormalClassForNormal(params) {
  return request({
    url: "/api/add/no/class/student/to/normal/class/for/normal",
    data: qs.stringify(params),
    method: "post",
  });
}

//无班级学员转为跟班试听
export function addNoClassStudentToNormalClassForAudition(params) {
  return request({
    url: "/api/add/no/class/student/to/normal/class/for/audition",
    data: qs.stringify(params),
    method: "post",
  });
}

//试听学员列表
export function getAuditionClassAuditionStudentList(params) {
  return request({
    url: "/api/get/audition/class/audition/student/list",
    params,
    method: "get",
  });
}

//添加班级并添加商品接口 （试听班级和正式班级）
export function addClassAndGoods(params) {
  return request({
    url: "/api/add/classes/and/goods",
    data: qs.stringify(params),
    method: "post",
  });
}

//获得正式班接口
export function getNormalClassesList(params) {
  return request({
    url: "/api/get/normal/classes/list",
    params,
    method: "get",
  });
}

//获得正式学员列表
export function getNormalClassNormalStudentList(params) {
  return request({
    url: "/api/get/normal/class/normal/student/list",
    params,
    method: "get",
  });
}

//根据班级ID查询教学计划
export function getTchTeachingPlan(params) {
  return request({
    url: "/api/tch/class/get/teachingPlan",
    params,
    method: "get",
  });
}

//查询所有跟班试听学员
export function getNormalClassAuditionStudentList(params) {
  return request({
    url: "/api/get/normal/class/audition/student/list",
    params,
    method: "get",
  });
}

//获得学生全部班级

export function getStudentAllClassList(params) {
  return request({
    url: "/api/get/student/all/classes/list",
    params,
    method: "get",
  });
}

//试听学员转为正式学员
export function addAuditionClassStudentToNormalClassForNormal(params) {
  return request({
    url: "/api/add/auditon/class/student/to/normal/class/for/normal",
    data: qs.stringify(params),
    method: "post",
  });
}

//查询订单
export function getOrderList(params) {
  return request({
    url: "/api/get/order/list",
    params,
    method: "get",
  });
}

//查询退费订单
export function getRefundOrderList(params) {
  return request({
    url: "/api/get/refund/order/list",
    params,
    method: "get",
  });
}

//查询所有校区学员
export function getStudentListForClassAddStudent(params) {
  return request({
    url: "/api/get/student/list/for/class/add/student",
    params,
    method: "get",
  });
}

//获取公开课课程体系

export function getAuditionCurriculumList(params) {
  return request({
    url: "/api/get/audition/curriculum/list",
    params,
    method: "get",
  });
}


//获取学员班级列表
export function getStuClassList(params) {
  return request({
    url: "/api/stu/class/get/classlist",
    params,
    method: "get",
  });
}

//获取班级教学计划
export function getStuTeachingPlan(params) {
  return request({
    url: "/api/stu/class/get/teachingPlan",
    params,
    method: "get",
  });
}

//获得学校科目权限列表
export function getSchoolSubjectList(params) {
  return request({
    url: "/api/get/school/subject/list",
    params,
    method: "get",
  });
}

//获取学校公开课课程体系
export function getAuditionCurriculumListNoPage(params) {
  return request({
    url: "/api/get/audition/curriculum/list",
    params,
    method: "get",
  });
}

//获取学校正式课课程体系
export function getNormalCurriculumListNoPage(params) {
  return request({
    url: "/api/get/normal/curriculum/list",
    params,
    method: "get",
  });
}

//根据班级ID班级学员
export function getStudentListByClassId(params) {
  return request({
    url: "/api/get/student/list/by/class/id",
    params,
    method: "get",
  });
}

//正式学员调班
export function normalClassNormalStudentChangeClass(params) {
  return request({
    url: "/api/normal/class/student/change/class",
    data: qs.stringify(params),
    method: "post",
  });
}

//查询退班学员订单信息
export function getOrderByStudentIdAndClassId(params) {
  return request({
    url: "/api/get/order/by/studentid/and/classid",
    params,
    method: "get",
  });
}

//正式学员退班
export function normalClassOrAuditionClassStudentOutClass(params) {
  return request({
    url: "/api/normal/class/or/audition/class/student/out/class",
    data: qs.stringify(params),
    method: "post",
  });
}

//添加意向客户接口
export function addIntendedStudent(params) {
  return request({
    url: "/api/add/intended/student",
    data: qs.stringify(params),
    method: "post",
  });
}

//查询意向学员接口
export function getIntendedStudentList(params) {
  return request({
    url: "/api/get/intended/student/list",
    params,
    method: "get",
  });
}

/**
 * 意向客户仅转为试听或者正式
 * @param {*} params 
 * @returns 
 */
export function updateIndendedStudentToAuditionOrNormalOnly(params) {
  return request({
    url: "/java-api/school/stu/batchConvert",
    ...postRestArgs(params, false)
  });
}


//取消意向客户转化
export function cancelIntendedRelation(params) {
  return request({
    url: "/api/cancel/intended/relation",
    data: qs.stringify(params),
    method: "post",
  });
}

//查询试听学员
export function getAuditionStudentList(params) {
  return request({
    url: "/api/get/audition/student/list",
    params,
    method: "get",
  });
}

//试听成功

export function updateAutidionSuccess(params) {
  return request({
    url: "/api/update/audition/student/success",
    data: qs.stringify(params),
    method: "post",
  });
}

//试听失败
export function updateAutidionFailed(params) {
  return request({
    url: "/api/update/audition/student/failed",
    data: qs.stringify(params),
    method: "post",
  });
}



export function getFormalStudentListForRefund(params) {
  return request({
    url: "/api/get/student/list/for/refund",
    params,
    method: "get",
  });
}


export function getFormalStudentList(params) {
  return request({
    url: "/api/get/normal/student/list/by/condition",
    params,
    method: "get",
  });
}
//新增试听学员---过滤一下
export function getNoXmStuForClassAddStu(params) {
  return request({
    url: "/api/getNoXmStuForClassAddStu",
    params: params,
    method: "get"
  });
}

export function getFormalStudentList1(params) {
  return request({
    url: "/api/get/normal/student/list/by/condition",
    params,
    method: "get",
    noLoading: true

  });
}

export function getAllStuList(params) {
  return request({
    url: "/api/tch/getAllStuList",
    params,
    method: "get",
    noLoading: true
  });
}

export function getStuListExceptQuiteAndDeleteStu(params) {
  return request({
    url: "/api/tch/getStuListExceptQuiteAndDeleteStu",
    params,
    method: "get",
    noLoading: true
  });
}

//新增试听学员
export function addAuditionStudent(params) {
  return request({
    url: "/api/add/audition/student",
    data: qs.stringify(params),
    method: "post",
  });
}

//获得校区的授权信息
export function getSchoolCurriculumList(params) {
  return request({
    url: "/api/get/school/curriculum/list",
    params,
    method: "get",
  });
}

//获得课程体系的授权信息
export function getSchoolCampusCurriculumAuthData(params) {
  return request({
    url: "/api/get/school/campus/curriculum/auth/data",
    params,
    method: "get",
  });
}

//更新校区课程体系默认价格
export function updateSchoolCurriculumPermissionPrice(params) {
  return request({
    url: "/api/update/school/curriculum/permision/price",
    data: qs.stringify(params),
    method: "post",
  });
}

//课程体系授权给分校
export function addOrDeleteCampusCurriculumAuth(params) {
  return request({
    url: "/api/add/or/delete/campus/curriculum/auth",
    data: qs.stringify(params),
    method: "post",
  });
}

//获取用户的所属校区
export function getUserCampusList(params) {
  return request({
    url: "/api/get/user/campus/list",
    params,
    method: "get",
  });
}

//获得分校科目权限
export function getCampusSubjectList(params) {
  return request({
    url: "/api/get/campus/subject/list",
    params,
    method: "get",
  });
}

//获得校区课程体系列表
export function getCampusCurriculumtList(params) {
  return request({
    url: "/api/get/campus/curriculum/list",
    params,
    method: "get",
  });
}


//获得校区具有课程体系权限的教师列表
export function getCampusTeacherList(params) {
  return request({
    url: "/api/get/campus/teacher/list",
    params,
    method: "get",
  });
}

//获得校区课程体系列表
export function getCampusCurriculumListForOrder(params) {
  return request({
    url: "/api/get/campus/curriculum/list/for/order",
    params,
    method: "get",
  });
}

//获得校区用户列表
export function getCampusUserList(params) {
  return request({
    url: "/api/get/campus/user/list",
    params,
    method: "get",
  });
}

//更新或添加学校收款账户
export function addOrUpdateOtherEducationalInstitutionAccount(params) {
  return request({
    url: "/api/addOrUpdate/school/account",
    data: qs.stringify(params),
    method: "post",
  });
}

//查询校区账户列表
export function getEducationalInstitutionAccountList(params) {
  return request({
    url: "/api/get/school/account/list",
    params,
    method: "get",
  });
}

//获得分校收款账户列表
export function getCampusAccountList(params) {
  return request({
    url: "/api/get/campus/account/list",
    params,
    method: "get",
  });
}

//创建收据接口
export function createChargeReceipt(params) {
  return request({
    url: "/api/create/charge/receipt",
    data: qs.stringify(params),
    method: "post",
  });
}

//收据查询接口
export function getReceiptList(params) {
  return request({
    url: "/api/get/receipt/list",
    params,
    method: "get",
  });
}

//查询收据的商品
export function getReceiptChargeGoodsList(params) {
  return request({
    url: "/api/get/receipt/charge/goods/list",
    params,
    method: "get",
  });
}

//查询学员欠费订单
export function getStudentNotPayReceiptList(params) {
  return request({
    url: "/api/get/student/not/page/receipt/list",
    params,
    method: "get",
  });
}

//获取未分班学员列表
export function getNotDivideStudentList(params) {
  return request({
    url: "/api/get/no/divide/student/list",
    params,
    method: "get",
  });
}

//学员入班操作
export function addStudentClassRelation(params) {
  return request({
    url: "/api/add/student/class/relation",
    data: qs.stringify(params),
    method: "post",
  });
}

//获得班级学员列表
export function getClassStudentList(params) {
  return request({
    url: "/api/get/class/student/list",
    params,
    method: "get",
  });
}
//删除学员班级关系
export function delStudentClassRelation(params) {
  return request({
    url: "/api/del/student/class/relation",
    data: qs.stringify(params),
    method: "post",
  });
}

//获取校区排课信息
export function getTeachingPlanList(params) {
  return request({
    url: "/api/get/teaching/plan/list",
    params,
    method: "get",
  });
}

//获得教学计划对应的学生计划列表
export function getTeachingPlanStuList(params) {
  return request({
    // url: "/api/get/teaching/plan/stu/list",
    url: "/api/getTeachingPlanStuListWithXmArr",
    params,
    method: "get",
  });
}

//更新教学计划签到信息
export function updateTeachingPlanSignInfo(params) {
  return request({
    url: "/api/update/teaching/plan/sign/info",
    data: qs.stringify(params),
    method: "post",
  });
}


//上课点名-单独点名学员不更新上课状态
export function updateStuTeachingPlanSignInfo(params) {
  return request({
    url: "/api/update/stu/teaching/plan/sign/state",
    data: qs.stringify(params),
    method: "post",
  });
}

//向教学计划中添加学员
export function addStuToTeachingPlan(params) {
  return request({
    url: "/api/add/stu/to/teaching/plan",
    data: qs.stringify(params),
    method: "post",
  });
}

//教学计划移除学员
export function deleteStuOfTeachingPlan(params) {
  return request({
    url: "/api/delete/stu/of/teaching/plan",
    data: qs.stringify(params),
    method: "post",
  });
}

//重置学员签到状态
export function deleteStuTeachingPlanSignInfo(params) {
  return request({
    url: "/api/delete/stu/teaching/plan/sign/state",
    data: qs.stringify(params),
    method: "post",
  });
}


//获得调课页面学员
export function getStuListForChangeStuTchPlan(params) {
  return request({
    url: "/api/get/stu/list/for/change/stu/tch/plan",
    params,
    method: "get",
  });
}

//临时调课接口
export function changeStuTchPlan(params) {
  return request({
    url: "/api/change/stu/tch/plan",
    data: qs.stringify(params),
    method: "post",
  });
}

//获得调课页面用的教学计划列表
export function getTchPlanListForChangeStuTchPlan(params) {
  return request({
    url: "/api/get/tch/plan/list/for/change/stu/tch/plan",
    params,
    method: "get",
  });
}

//取消调课
export function cancelChangeStuTchPlan(params) {
  return request({
    url: "/api/cancel/change/stu/tch/plan",
    data: qs.stringify(params),
    method: "post",
  });
}

//新学员报名
export function addNormalStudent(params) {
  return request({
    url: "/api/add/normal/student",
    data: qs.stringify(params),
    method: "post",
  });
}

//试听课排课
export function addAuditionTeachingPlan(params) {
  return request({
    url: "/api/add/auditon/teaching/plan",
    data: qs.stringify(params),
    method: "post",
  });
}

//获得校区所有课程体系
export function getCampusAllCurriculumtList(params) {
  return request({
    url: "/api/get/campus/all/curriculum/list",
    params,
    method: "get",
  });
}

//试听学员跟班试听接口
export function addAuditionStuToTeachingPlan(params) {
  return request({
    url: "/api/add/audition/stu/to/teaching/plan",
    data: qs.stringify(params),
    method: "post",
  });
}

//查询学员可退费或可结转收据
export function getReceiptListForRefund(params) {
  return request({
    url: "/api/get/receipt/list/for/refund",
    params,
    method: "get",
  });
}

//结转接口
export function createTransferReceipt(params) {
  return request({
    url: "/api/create/transfer/receipt",
    data: qs.stringify(params),
    method: "post",
  });
}

//退费接口
export function createRefundReceipt(params) {
  return request({
    url: "/api/create/refund/receipt",
    data: qs.stringify(params),
    method: "post",
  });
}

//欠费补交接口
export function createAfterPayReceipt(params) {
  return request({
    url: "/api/create/after/pay/receipt",
    data: qs.stringify(params),
    method: "post",
  });
}

//查询试听学员试听记录
export function getStudentAuditionTchPlan(params) {
  return request({
    url: "/api/get/student/audition/tch/plan",
    params,
    method: "get",
  });
}

//获得学员正式班级列表
export function getStudentNormalClassList(params) {
  return request({
    url: "/api/get/student/normal/class/list",
    params,
    method: "get",
  });
}

//获得学生已签到的教学计划

export function getStuClassStuTchPlanList(params) {
  return request({
    url: "/api/get/stu/class/stu/tch/plan/list",
    params,
    method: "get",
  });
}



//获得可调入的班级列表
export function getClassListForStuChangeClass(params) {
  return request({
    url: "/api/get/class/list/for/stu/change/class",
    params,
    method: "get",
  });
}

//选择入班讲次
export function getClassTchPlanList(params) {
  return request({
    url: "/api/get/class/tch/plan/list",
    params,
    method: "get",
  });
}

//调班接口
export function changeStuClass(params) {
  return request({
    url: "/api/change/stu/class",
    data: qs.stringify(params),
    method: "post",
  });
}

//向教学计划内添加学员功能里的查找所有正式学员列表接口
export function getFormalStudentListForAddToTchPlan(params) {
  return request({
    url: "/api/get/formal/student/list/for/addto/tch/plan",
    params,
    method: "get",
  });
}

//获得分校区体系列表-分页
export function getCampusCurriculumtListByPage(params) {
  return request({
    url: "/api/get/campus/curriculum/list/by/page",
    params,
    method: "get",
  });
}
//获得分校区体系列表-分页2
export function getCurriculumListForClassAddLesson(params) {
  return request({
    url: "/api/getCurriculumListForClassAddLesson",
    params,
    method: "get",
  });
}

//添加/更新意向学员接口
export function addOrUpdateIntendedStudent(params) {
  return request({
    url: "/api/add/or/update/intended/student",
    data: qs.stringify(params),
    method: "post",
  });
}

//正式学员修改信息
export function addOrUpdateNormalStudent(params) {
  return request({
    url: "/api/add/or/update/normal/student",
    data: qs.stringify(params),
    method: "post",
  });
}

//更新收据信息
export function updateReceipt(params) {
  return request({
    url: "/api/update/receipt",
    data: qs.stringify(params),
    method: "post",
  });
}


//更新讲次内容
export function updateTeachingPlan(params) {
  return request({
    url: "/api/update/teaching/plan",
    data: qs.stringify(params),
    method: "post",
  });
}

//校区权限管理-创建角色
export function createOrUpdateSchoolRole(params) {
  return request({
    url: "/api/create/or/update/school/role",
    data: qs.stringify(params),
    method: "post",
  });
}

//校区权限管理-角色列表
export function getSchoolRoleList(params) {
  return request({
    url: "/api/get/school/role/list",
    params,
    method: "get",
  });
}

//校区权限管理-删除角色
export function deleteSchoolRole(params) {
  return request({
    url: "/api/delete/school/role",
    data: qs.stringify(params),
    method: "post",
  });
}

//校区的社区轮播图查询
export function getZoneBannerList(params) {
  return request({
    url: "/api/get/zone/banner/list",
    params,
    method: "get",
  });
}

//校区添加或更新社区轮播图
export function addOrUpdateZoneBanner(params) {
  return request({
    url: "/api/add/or/update/zone/banner",
    data: qs.stringify(params),
    method: "post",
  });
}

//校区删除社区轮播图
export function deleteZoneBanner(params) {
  return request({
    url: "/api/delete/zone/banner",
    data: qs.stringify(params),
    method: "post",
  });
}

//更改老师账号信息
export function tchUpdateTchInfo(params) {
  return request({
    url: "/api/tch/update/tch/info",
    data: qs.stringify(params),
    method: "post",
  });
}

//更新学生账号信息
export function stuUpdateStudentInfo(params) {
  return request({
    url: "/api/stu/update/student/info",
    data: qs.stringify(params),
    method: "post",
  });
}

/**
 * 学生修改学生密码
 * @param {*} params 
 * @returns 
 */
export function stuUpdateStudentPassword(params) {
  return request({
    url: "/java-api/student/stu/updatePwd",
    ...postRestArgs(params, false)
  });
}

//更新教师密码
export function tchUpdateUserPassword(params) {
  return request({
    url: "/api/tch/update/user/password",
    data: qs.stringify(params),
    method: "post",
  });
}

//查询培训视频列表
export function getVideoList(params) {
  return request({
    url: "/api/get/video/list",
    params,
    method: "get",
  });
}

//查询物料列表
export function getMeterialGroupList(params) {
  return request({
    url: "/api/get/meterial/group/list",
    params,
    method: "get",
  });
}

//删除意向学员
export function deleteIntendedStudent(params) {
  return request({
    url: "/api/delete/intended/student",
    data: qs.stringify(params),
    method: "post",
  });
}

//删除试听讲次
export function deleteAuditionTeachingPlan(params) {
  return request({
    url: "/api/delete/audition/teaching/plan",
    data: qs.stringify(params),
    method: "post",
  });
}

//删除校区物品
export function deleteGoods(params) {
  return request({
    url: "/api/delete/goods",
    data: qs.stringify(params),
    method: "post",
  });
}

//删除校区账户
export function deleteEducationalInstitutionAccount(params) {
  return request({
    url: "/api/delete/school/account",
    data: qs.stringify(params),
    method: "post",
  });
}

// //删除学员
// export function deleteStudents(params) {
//   return request({
//     url: "/api/delete/students",
//     data: qs.stringify(params),
//     method: "post",
//   });
// }
//删除学员
export function deleteStudents(params) {
  return request({
    url: "/api/delete/students/without/limit",
    data: qs.stringify(params),
    method: "post",
  });
}

//收据作废
export function inValidReceipt(params) {
  return request({
    url: "/api/invalid/receipt",
    data: qs.stringify(params),
    method: "post",
  });
}



//校区权限管理-获得标题列表
export function getPermissionList(params) {
  return request({
    url: "/api/get/permission/list",
    params,
    method: "get",
  });
}


//查询物料类型
export function getMeterialTypeList(params) {
  return request({
    url: "/api/get/meterial/type/list",
    params,
    method: "get",
  });
}


//查询视频分类列表
export function getVideoTypeList(params) {
  return request({
    url: "/api/get/video/type/list",
    params,
    method: "get",
  });
}

//获得校区权益数据
export function getSchoolRightInfo(params) {
  return request({
    url: "/api/get/school/right/info",
    params,
    method: "get",
  });
}

//验证用户是否有对应页面的权限
export function testUserAuth(params) {
  return request({
    url: "/api/test/user/auth",
    params,
    method: "get",
  });
}

/**
 * 学生退学
 * @param {*} params 
 * @returns 
 */
export function quitSchool(params) {
  return request({
    url: "/java-api/school/stu/quit",
    ...postRestArgs(params, false)
  });
}


/**
 * 学生复学
 * @param {*} params 
 * @returns 
 */
export function backSchool(params) {
  return request({
    url: "/java-api/school/stu/back",
    ...postRestArgs(params, false)
  });
}


//获得收据的账号列表
export function getReceiptAccountList(params) {
  return request({
    url: "/api/get/receipt/account/list",
    params,
    method: "get",
  });
}

//获得退费、结转商品列表
export function getReceiptRefundGoodsList(params) {
  return request({
    url: "/api/get/receipt/refund/goods/list",
    params,
    method: "get",
  });
}

//获得补交收据商品详情
export function getReceiptAfterPayGoodsList(params) {
  return request({
    url: "/api/get/receipt/after/pay/goods/list",
    params,
    method: "get",
  });
}

//获得转班收据详情
export function getReceiptChangeGoodsList(params) {
  return request({
    url: "/api/get/receipt/change/goods/list",
    params,
    method: "get",
  });
}


/**
 * 教师端重置学生密码
 * @param {*} params 
 * @returns 
 */
export function updateStuUserPassword(params) {
  return request({
    url: "/java-api/school/stu/resetPwd",
    ...postRestArgs(params, false)
  });
}



//获得分校对应的科目列表及体系列表
export function getCampusSubjectListWithCurriculumInfo(params) {
  return request({
    url: "/api/get/campus/subject/list/whit/curriculum/info",
    params,
    method: "get",
  });
}


//保存Python作品
export function savePyWork(params) {
  return request({
    url: "/api/save/py/work",
    data: qs.stringify(params),
    method: "post",
  });
}

//获得Python自由创作作品详情
export function getPyWorkContent(params) {
  return request({
    url: "/api/get/py/work/content",
    params,
    method: "get",
  });
}

//保存PY课堂作品
export function savePyTchWork(params) {
  return request({
    url: "/api/save/py/tch/work",
    data: qs.stringify(params),
    method: "post",
  });
}

//校区自有课程-新建课程体系
export function addOrUpdateSchoolSelfCurriculum(params) {
  return request({
    url: "/api/add/or/update/school/self/curriculum",
    data: qs.stringify(params),
    method: "post",
  });
}

//获得学校课程体系
export function getSchoolSelfCurriculumList(params) {
  return request({
    url: "/api/get/school/self/curriculum/list",
    params,
    method: "get",
  });
}

//学校查看课程体系详情
export function getSchoolSelfCurriculum(params) {
  return request({
    url: "/api/get/school/self/curriculum",
    params,
    method: "get",
  });
}


//添加或更新校区自有课程
export function addOrUpdateSchoolSelfCurriculumMaterial(params) {
  return request({
    url: "/api/add/or/update/school/self/curriculum/material",
    data: qs.stringify(params),
    method: "post",
  });
}

//删除校区课程
export function deleteSchoolSelfCurriculumMaterial(params) {
  return request({
    url: "/api/delete/school/self/curriculum/material",
    data: qs.stringify(params),
    method: "post",
  });
}

//删除校区课程体系
export function deleteSchoolSelfCurriculum(params) {
  return request({
    url: "/api/delete/school/self/curriculum",
    data: qs.stringify(params),
    method: "post",
  });
}


//获得校区自有体系课程
export function getCurriculum(params) {
  return request({
    url: "/api/get/curriculum",
    params,
    method: "get",
  });
}

//校区课程提交审核
export function submitOrCancelSchoolSelfCurriculum(params) {
  return request({
    url: "/api/submit/or/cancel/school/self/curriculum",
    data: qs.stringify(params),
    method: "post",
  });
}

//更新学校剩余流量
export function udpateSchooRemainTraffic(params) {
  return request({
    url: "/api/update/school/remain/traffic",
    data: qs.stringify(params),
    method: "post",
    noLoading: true
  });
}

//获得校区流量花费详情
export function getSchooTrafficCostList(params) {
  return request({
    url: "/api/get/school/traffic/cost/list",
    params,
    method: "get",
  });
}

export function checkSchoolSelfCurriculum(params) {
  return request({
    url: "/api/check/school/self/curriculum",
    data: qs.stringify(params),
    method: "post",
  });
}



//获得校区空间详情
export function getSchoolSelfLessionList(params) {
  return request({
    url: "/api/get/school/self/lession/list",
    params,
    method: "get",
  });
}

//获得校区题库
export function getSchoolQuestionBankList(params) {
  return request({
    url: "/api/exam/get/school/question/bank/list",
    params,
    method: "get",
  });
}

//添加或编辑题库

export function addOrUpdateSchoolQuestionBank(params) {
  return request({
    url: "/api/exam/add/or/update/school/question/bank",
    data: qs.stringify(params),
    method: "post",
  });
}

//删除题库
export function deleteSchoolQuestionBank(params) {
  return request({
    url: "/api/exam/delete/school/question/bank",
    data: qs.stringify(params),
    method: "post",
  });
}

//改变题库发布状态
export function changeSchoolQuestionBankPostState(params) {
  return request({
    url: "/api/exam/change/school/question/bank/post/state",
    data: qs.stringify(params),
    method: "post",
  });
}

//添加试题
export function addOrUpdateSchoolQuestion(params) {
  return request({
    url: "/api/exam/add/or/update/school/question",
    data: qs.stringify(params),
    method: "post",
  });
}

//获得题目列表
export function getSchoolQuestionList(params) {
  return request({
    url: "/api/exam/get/school/question/list",
    params,
    method: "get",
  });
}

//删除题目
export function deleteSchoolQuestion(params) {
  return request({
    url: "/api/exam/delete/school/question",
    data: qs.stringify(params),
    method: "post",
  });
}

//添加考试
export function addExam(params) {
  return request({
    url: "/api/exam/add/exam",
    data: qs.stringify(params),
    method: "post",
  });
}

//考试题库来源
export function getSchoolQuestionBankListForPostExam(params) {
  return request({
    url: "/api/exam/get/school/question/bank/for/post/exam",
    params,
    method: "get",
  });
}

//列出所有试题
export function getExamQuestionListForPostExam(params) {
  return request({
    url: "/api/exam/get/exam/question/list/for/post/exam",
    params,
    method: "get",
  });
}

//根据班级查询考试学员
export function getExamClassListForPostExam(params) {
  return request({
    url: "/api/exam/get/exam/class/list/for/post/exam",
    params,
    method: "get",
  });
}

//根据班级id组获得学员列表
export function getExamStuListByClassIdsForPostExam(params) {
  return request({
    url: "/api/exam/get/exam/stu/list/by/class/ids/for/post/exam",
    params,
    method: "get",
  });
}

//获得学员列表
export function getExamStuListForPostExam(params) {
  return request({
    url: "/api/exam/get/exam/stu/list/for/post/exam",
    params,
    method: "get",
  });
}

//添加试卷
export function addPaper(params) {
  return request({
    url: "/api/exam/add/paper",
    data: qs.stringify(params),
    method: "post",
  });
}

//获得试卷列表
export function getSchoolPaperList(params) {
  return request({
    url: "/api/exam/school/paper/list",
    params,
    method: "get",
  });
}

//删除试卷
export function deletePaper(params) {
  return request({
    url: "/api/exam/delete/paper",
    data: qs.stringify(params),
    method: "post",
  });
}

//获得试卷试题列表
export function getCheckPaperQuestionList(params) {
  return request({
    url: "/api/exam/get/check/paper/question/list",
    params,
    method: "get",
  });
}

//查询考试列表
export function getSchoolExamList(params) {
  return request({
    url: "/api/exam/get/school/exam/list",
    params,
    method: "get",
  });
}

export function changeState(params) {
  return request({
    url: "/api/exam/change/exam/post/state",
    data: qs.stringify(params),
    method: "post",
  });
}



//删除考试
export function deleteExam(params) {
  return request({
    url: "/api/exam/delete/exam",
    data: qs.stringify(params),
    method: "post",
  });
}

//编辑试卷题目
export function editPaperQuestion(params) {
  return request({
    url: "/api/exam/edit/paper/question",
    data: qs.stringify(params),
    method: "post",
  });
}

//编辑考试
export function editExam(params) {
  return request({
    url: "/api/exam/edit/exam",
    data: qs.stringify(params),
    method: "post",
  });
}

//布置练习
export function addPractice(params) {
  return request({
    url: "/api/exam/add/practice",
    data: qs.stringify(params),
    method: "post",
  });
}

//查看练习列表
export function getSchoolPracticeList(params) {
  return request({
    url: "/api/exam/get/school/practice/list",
    params,
    method: "get",
  });
}

//获得考试学生列表
export function getExamStuList(params) {
  return request({
    url: "/api/exam/get/exam/stu/list",
    params,
    method: "get",
  });
}

//添加考试考生
export function addExamStu(params) {
  return request({
    url: "/api/exam/add/exam/stu",
    data: qs.stringify(params),
    method: "post",
  });
}

//删除考试学生
export function deleteExamStu(params) {
  return request({
    url: "/api/exam/delete/exam/stu",
    data: qs.stringify(params),
    method: "post",
  });
}

//编辑练习
export function editPractice(params) {
  return request({
    url: "/api/exam/edit/practice",
    data: qs.stringify(params),
    method: "post",
  });
}

//学生获得考试列表
export function getStuExamList(params) {
  return request({
    url: "/api/stuexam/get/stu/exam/list",
    params,
    method: "get",
  });
}

//获得考试对应的题目
export function getStuExamQuestionList(params) {
  return request({
    url: "/api/stuexam/get/stu/exam/question/list",
    params,
    method: "get",
    // noLoading: true
  });
}

//学生考试提交单个试题
export function checkSingleQuestion(params) {
  return request({
    url: "/api/stuexam/check/single/question",
    data: qs.stringify(params),
    method: "post",
  });
}

//同步综合题答案
export function getStuQuestionAnswer(params) {
  return request({
    url: "/api/stuexam/get/stu/question/answer",
    params,
    method: "get"
  });
}

//学生提交试卷
export function submitStuPaper(params) {
  return request({
    url: "/api/stuexam/submit/paper",
    data: qs.stringify(params),
    method: "post",
  });
}

//学生获得练习列表
export function getStuPracticeList(params) {
  return request({
    url: "/api/stuexam/get/stu/practice/list",
    params,
    method: "get",
  });
}

//考试考生排行榜
export function getExamRanking(params) {
  return request({
    url: "/api/common/exam/get/exam/rankling",
    params,
    method: "get",
  });
}

//获得考生答题记录
export function getExamResultQuestionListForTch(params) {
  return request({
    url: "/api/exam/get/exam/result/question/list/for/tch",
    params,
    method: "get",
  });
}

//老师判题接口
export function checkStuExamQuestion(params) {
  return request({
    url: "/api/exam/check/stu/exam/question",
    data: qs.stringify(params),
    method: "post",
  });
}

//删除学生练习记录
export function deletePracticeRecord(params) {
  return request({
    url: "/api/stuexam/delete/practice/record",
    data: qs.stringify(params),
    method: "post",
  });
}

//删除学生考试记录
export function deleteStuExam(params) {
  return request({
    url: "/api/exam/delete/stu/exam",
    data: qs.stringify(params),
    method: "post",
  });
}

//学生作答记录
export function getExamResultQuestionList(params) {
  return request({
    url: "/api/stuexam/get/exam/result/question/list",
    params,
    method: "get",
  });
}

//学生获得错题列表
export function getStuWrongQuestionList(params) {
  return request({
    url: "/api/stuexam/get/stu/wrong/question/list",
    params,
    method: "get",
  });
}
//删除学生错题
export function deleteStuWrongQuestion(params) {
  return request({
    url: "/api/stuexam/delete/stu/wrong/question",
    data: qs.stringify(params),
    method: "post",
  });
}

//新学生获得错题列表
export function getStuWrongQuestionListForNew(params) {
  return request({
    url: "/api/stuexam/getStuWrongQuestionListForNew",
    params,
    method: "get",
  });
}

//错题判题接口
export function checkWrongQuestion(params) {
  return request({
    url: "/api/stuexam/checkWrongQuestion",
    data: qs.stringify(params),
    method: "post",
  });
}

//老师确认成绩
export function updateStuExamTchComment(params) {
  return request({
    url: "/api/exam/update/stu/exam/tch/comment",
    data: qs.stringify(params),
    method: "post",
  });
}

//拷贝试卷
export function copyPaper(params) {
  return request({
    url: "/api/exam/copy/paper",
    data: qs.stringify(params),
    method: "post",
  });
}

//验证校区是否有题库权限
export function testSchoolQustionBankAuth(params) {
  return request({
    url: "/api/test/school/question/bank/auth",
    params,
    method: "get",
  });
}

//教师端-我的教室权限验证（用于备课页面）
export function tchGetIsTchHaveCurriculumAuthWithCampusId(params) {
  return request({
    url: "/api/tch/get/is/tch/have/curriculum/auth/with/campus/id",
    params,
    method: "get",
  });
}

//删除排课
export function deleteNormalClassTchPlan(params) {
  return request({
    url: "/api/delete/normal/class/tch/plan",
    data: qs.stringify(params),
    method: "post",
  });
}

//获得校区文件
export function getSchoolFileList(params) {
  return request({
    url: "/api/get/school/file/list",
    params,
    method: "get",
  });
}

//批量调课
export function bulkUpdateTeachingPlan(params) {
  return request({
    url: "/api/bulk/update/teaching/plan",
    data: qs.stringify(params),
    method: "post",
  });
}

//插入课程
export function addSingleNormalClassTchPlan(params) {
  return request({
    url: "/api/add/single/normal/class/tch/plan",
    data: qs.stringify(params),
    method: "post",
  });
}

//批量导入学员
export function bulkAddNormalStudent(params) {
  return request({
    url: "/api/bulk/add/normal/student",
    data: qs.stringify(params),
    method: "post",
  });
}

//绑定微信，获得带参二维码
export function getQrCode(params) {
  return request({
    url: "/api/wechat/get/qr/code",
    params,
    method: "get",
  });
}

//解除老师微信号绑定
export function deleteUserOpenId(params) {
  return request({
    url: "/api/delete/user/openid",
    data: qs.stringify(params),
    method: "post",
  });
}

//解除学生微信绑定
export function deleteStuUserOpenId(params) {
  return request({
    url: "/api/delete/stu/user/openid",
    data: qs.stringify(params),
    method: "post",
  });
}

//家校互通-发送签到消息
export function sendSignTemplateMessage(params) {
  return request({
    url: "/api/wechat/send/sign/template/message",
    data: qs.stringify(params),
    method: "post",
  });
}

//发送老师点评模板消息
export function sendTchWorkTchCommentTemplateMessage(params) {
  return request({
    url: "/api/wechat/send/tch/work/tch/comment/template/message",
    data: qs.stringify(params),
    method: "post",
  });
}

//更新讲次签到信息
export function updateTchPlanSignState(params) {
  return request({
    url: "/api/update/tch/plan/sign/state",
    data: qs.stringify(params),
    method: "post",
  });
}

//批量导入意向学员
export function bulkAddIntendedStudent(params) {
  return request({
    url: "/api/bulk/add/intended/student",
    data: qs.stringify(params),
    method: "post",
  });
}

//批量导入试听学员
export function bulkAddAuditionStudent(params) {
  return request({
    url: "/api/bulk/add/audition/student",
    data: qs.stringify(params),
    method: "post",
  });
}

//收据关联班级
export function getClassListForReceiptChargeGoods(params) {
  return request({
    url: "/api/get/class/list/for/receipt/charge/goods",
    params,
    method: "get",
  });
}

//绑定班级接口
export function updateReceiptChargeClassGoodsClass(params) {
  return request({
    url: "/api/update/receipt/charge/class/goods/class",
    data: qs.stringify(params),
    method: "post",
  });
}

//批量修改上课日期
export function bulkUpdateTeachingPlanPeriod(params) {
  return request({
    url: "/api/bulk/update/teaching/plan/period",
    data: qs.stringify(params),
    method: "post",
  });
}

//班级结业
export function updateClassesEndClassState(params) {
  return request({
    url: "/api/update/classes/end/class/state",
    data: qs.stringify(params),
    method: "post",
  });
}

//更新课堂模板
export function updateTchPlanTemplate(params) {
  return request({
    url: "/api/tch/update/tch/plan/template",
    data: qs.stringify(params),
    method: "post",
  });
}

//老师查看通知
export function getTchNoticeList(params) {
  return request({
    url: "/api/get/tch/notice/list",
    params,
    method: "get",
  });
}

//学员课消统计
export function getStuClassCostDetailForm(params) {
  return request({
    url: "/api/get/stu/class/cost/detail/form",
    params,
    method: "get",
  });
}

//学员课消汇总表
export function getStuClassCostTotalForm(params) {
  return request({
    url: "/api/get/stu/class/cost/total/form",
    params,
    method: "get",
  });
}

//老师已查看消息
export function updateNoticeIsReatState(params) {
  return request({
    url: "/api/update/notice/is/read/state",
    data: qs.stringify(params),
    method: "post",
    noLoading: true,
  });
}

//超管重置员工密码
export function updateUserPassword(params) {
  return request({
    url: "/api/update/user/password",
    data: qs.stringify(params),
    method: "post",
  });
}

//同步老平台Scratch作品
export function getStuScratchWorks(params) {
  return request({
    url: "/newsys/get/sc/work/list/by/stu/id",
    params,
    method: "get",
  });
}

//同步Scratch作品
export function saveOldSysScWork(params) {
  return request({
    url: "/api/save/old/sys/sc/work",
    data: qs.stringify(params),
    method: "post",
  });
}

//同步Jrcode作品
export function saveOldSysJrWork(params) {
  return request({
    url: "/api/save/old/sys/jr/work",
    data: qs.stringify(params),
    method: "post",
  });
}

//补课教学计划接口
export function addSupplementTchPlan(params) {
  return request({
    url: "/api/add/supplement/tch/plan",
    data: qs.stringify(params),
    method: "post",
  });
}

//添加意向客户跟进记录
export function addOrUpdateIntendedStudentUseRecord(params) {
  return request({
    url: "/api/add/or/update/intended/student/user/record",
    data: qs.stringify(params),
    method: "post",
  });
}

//查询沟通记录
export function getIntendedStudentUserRecordList(params) {
  return request({
    url: "/api/get/intended/student/user/record/list",
    params,
    method: "get",
  });
}

//邀约查询
export function getIntendedStudentListByRealComeDate(params) {
  return request({
    url: "/api/get/intended/student/list/by/real/come/date",
    params,
    method: "get",
  });
}

//更新到访日期
export function updateIntendedStudentRealComeDate(params) {
  return request({
    url: "/api/update/intended/student/real/come/date",
    data: qs.stringify(params),
    method: "post",
  });
}

//删除沟通记录
export function deleteIntendedStudentUserRecord(params) {
  return request({
    url: "/api/delete/intended/student/user/record",
    data: qs.stringify(params),
    method: "post",
  });
}

//结束客户跟进
export function updateIntendedStudentStatus(params) {
  return request({
    url: "/api/update/intended/student/status",
    data: qs.stringify(params),
    method: "post",
  });
}

//账号有效期设置
export function bulkAddStudentUserRemainTime(params) {
  return request({
    url: "/api/bulk/add/student/user/remain/time",
    data: qs.stringify(params),
    method: "post",
  });
}

//获得老师课堂作品
export function getTchLesson(params) {
  return request({
    url: "/api/get/tch/lesson/work",
    params,
    method: "get",
  });
}

//老师保存课堂作品
export function saveTchLesson(params) {
  return request({
    url: "/api/save/tch/lesson/work",
    data: qs.stringify(params),
    method: "post",
  });
}


export function deleteTchLessonWork(params) {
  return request({
    url: "/api/delete/tch/lesson/work",
    data: qs.stringify(params),
    method: "post",
  });
}

//老师添加课程反馈信息
export function addCurriculumMaterialFeedback(params) {
  return request({
    url: "/api/add/curriculum/material/feedback",
    data: qs.stringify(params),
    method: "post",
  });
}

//查询老师课堂作品
export function getTchLessonWorkList(params) {
  return request({
    url: "/api/get/tch/lesson/work/list",
    params,
    method: "get",
  });
}

//生成授权URL
export function wechatAgentGetPreAuthUrl(params) {
  return request({
    url: "/api/wechat_agent/get/pre_auth_url",
    params,
    method: "get",
  });
}
//更新班级是否排课标志位

export function isCreate(params) {
  return request({
    url: "/api/update/classes/is/create/timetable",
    data: qs.stringify(params),
    method: "post",
  });
}
//给班级批量添加教学计划
export function toClass(params) {
  return request({
    url: "/api/bulk/add/tch/plan/to/class",
    data: qs.stringify(params),
    method: "post",
  });
}

//获得校区课程列表
export function lessonList(params) {
  return request({
    url: "/api/get/campus/lesson/list",
    params,
    method: "get",
  });
}
//获得校区课程列表2
export function getLessonListForClassAddLesson(params) {
  return request({
    url: "/api/getLessonListForClassAddLesson",
    params,
    method: "get",
  });
}

/**
 * 添加或编辑学员接口
 * @param {*} params 
 * @returns 
 */
export function addUpdateStudent(params) {
  return request({
    url: "/java-api/school/stu/create",
    ...postRestArgs(params, false)
  });
}

/**
 * 批量添加正式学员
 * @param {*} params 
 * @returns 
 */
export function addAllStudent(params) {
  return request({
    url: "/java-api/school/stu/importMessage",
    ...postRestArgs(params, false)
  });
}

export function newList(params) {
  return request({
    url: "/api/get/normal/student/list/by/condition",
    params,
    method: "get",
  });
}

//获得多个校区全部体系列表
export function allCurriculum(params) {
  return request({
    url: "/api/get/all/campus/all/curriculum/title/list",
    params,
    method: "get",
  });
}
//更新诺到访日期
export function updateIntendedStudentComeDate(params) {
  return request({
    url: "/api/update/intended/student/come/date",
    data: qs.stringify(params),
    method: "post",
  });
}

//清空教学计划接口
export function clearTchPlan(params) {
  return request({
    url: "/api/clear/tch/plan",
    data: qs.stringify(params),
    method: "post",
  });
}
//删除教学计划接口
export function delTchPlan(params) {
  return request({
    url: "/api/delete/tch/plan",
    data: qs.stringify(params),
    method: "post",
  });
}

//教师上课结课接口
export function updateTchPlanSignStateNew(params) {
  return request({
    url: "/api/update/tch/plan/sign/state/new",
    data: qs.stringify(params),
    method: "post",
  });
}
//为学生补课接口

export function makeUpClassForStudent(params) {
  return request({
    url: "/api/make/up/class/for/student",
    data: qs.stringify(params),
    method: "post",
  });
}
//学生签到接口 
export function stuSignInForClass(params) {
  return request({
    url: "/api/stu/sign/in/for/class",
    data: qs.stringify(params),
    method: "post",
  });
}
//师端获得学生本节课的作品完成情况
export function tchGetStuLessonTchWorkList(params) {
  return request({
    url: "/api/tch/get/stu/lesson/tch/work/list",
    params,
    method: "get",
  });
}

//师端获得学生本节课的作品完成情况
export function stuGetTchWorkListByStuTchPlanId(params) {
  return request({
    url: "/api/stu/get/tch/work/list/by/stu/tch/plan/id",
    params,
    method: "get",
  });
}
//获得学生缺课记录
export function getStuAbsenceRcord(params) {
  return request({
    url: "/api/get/stu/absence/record",
    params,
    method: "get",
  });
}
//获得学生上课记录
export function getStuClassRecord(params) {
  return request({
    url: "/api/get/stu/class/record",
    params,
    method: "get",
  });
}
//获得老师上课记录
export function getTchClassRecord(params) {
  return request({
    url: "/api/get/tch/class/record",
    params,
    method: "get",
  });
}
//保存学生作答记录
export function createTestExamStuRecord(params) {
  return request({
    url: "/api/stuexam/create/test/exam/stu/record",
    data: qs.stringify(params),
    method: "post",
  });
}

//获得学生当前作答情况和之前的作答记录
export function getStuPracticeAndRecord(params) {
  return request({
    url: "/api/stuexam/get/stu/practice/and/record",
    params,
    method: "get",
  });
}
//获得学生练习记录对应的做题记录
export function getPracticeRecordQuestionListForTch(params) {
  return request({
    url: "/api/exam/get/practice/record/question/list/for/tch",
    params,
    method: "get",
  });
}
//教师端获得学生当前作答情况和之前的作答记录
export function getStuPracticeAndRecordForTch(params) {
  return request({
    url: "/api/exam/get/stu/practice/and/record/for/tch",
    params,
    method: "get",
  });
}
//添加学校自有课程
export function addSchoolSelfLesson(params) {
  return request({
    url: "/api/add/school/self/lesson",
    data: qs.stringify(params),
    method: "post",
  });
}
//编辑学校自有课程
export function updateSchoolSelfLessonInfo(params) {
  return request({
    url: "/api/update/school/self/lesson",
    data: qs.stringify(params),
    method: "post",
  });
}
//根据自有课程体系id获得自有课程列表
export function getSchoolSelfLessonListByCurriculumId(params) {
  return request({
    url: "/api/get/school/self/lesson/list/by/curriculum/id",
    params,
    method: "get",
  });
}
//获得后台用户列表
export function getSchoolSelfLessonInfo(params) {
  return request({
    url: "/api/get/school/self/lesson/info",
    params,
    method: "get",
  });
}
//添加用户截屏记录
export function addCatchScreenRecord(params) {
  return request({
    url: "/api/add/catch/screen/record",
    data: qs.stringify(params),
    method: "post",
  });
}

//检测学校是否有oj功能权限
export function tesSchoolOjAuth(params) {
  return request({
    url: "/api/test/school/oj/auth",
    params,
    method: "get",
  });
}
//教师添加或更新题目
export function tchAddOrUpdateOjProblem(params) {
  return request({
    url: "/api/oj/tch/add/or/update/oj/problem",
    data: qs.stringify(params),
    method: "post",
  });
}
//获得问题来源列表
export function getOjProblemSourceList(params) {
  return request({
    url: "/api/oj/get/oj/problem/source/list",
    params,
    method: "get",
  });
}
//获得问题分组列表
export function getOjProblemTagGroupList(params) {
  return request({
    url: "/api/oj/get/oj/problem/tag/group/list",
    params,
    method: "get",
  });
}

//教师端获得自己创建的题目列表
export function tchGetOwnOjProblemList(params) {
  return request({
    url: "/api/oj/tch/get/own/oj/problem/list",
    params,
    method: "get",
  });
}
//教师获得题目列表，包括平台题目和学校题目
export function getSchoolOjProblemList(params) {
  return request({
    url: "/api/oj/get/school/oj/problem/list",
    params,
    method: "get",
  });
}
//教师获得题目列表，包括平台题目和学校题目，用于赛考中心-校区平台添加OJ题
export function getSchoolOjProblemForBankAdd(params) {
  return request({
    url: "/api/oj/getSchoolOjProblemForBankAdd",
    params,
    method: "get",
  });
}
//获得问题难度列表
export function getOjProblemDifficultyList(params) {
  return request({
    url: "/api/oj/get/oj/problem/difficulty/list",
    params,
    method: "get",
  });
}
//教师删除题目接口
export function tchUpdateOjProblemVisible(params) {
  return request({
    url: "/api/oj/tch/update/oj/problem/visible",
    data: qs.stringify(params),
    method: "post",
  });
}
//获得题单列表，包括平台题单和学校题单
export function getSchoolOjProblemlistList(params) {
  return request({
    url: "/api/oj/get/school/oj/problemlist/list",
    params,
    method: "get",
  });
}
//教师添加或更新题单
export function tchAddOrUpdateOjProblemList(params) {
  return request({
    url: "/api/oj/tch/add/or/update/oj/problemlist",
    data: qs.stringify(params),
    method: "post",
  });
}
//教师端获得自己创建的题单列表
export function tchGetOwnOjProblemlistList(params) {
  return request({
    url: "/api/oj/tch/get/own/oj/problemlist/list",
    params,
    method: "get",
  });
}
//教师删除题单
export function tchDeleteOjProblemList(params) {
  return request({
    url: "/api/oj/tch/delete/oj/problemlist",
    data: qs.stringify(params),
    method: "post",
  });
}
//教师给题单添加问题页面获得题目列表,去除了题单已包含的题目

export function tchGetOjProblemListForProblemList(params) {
  return request({
    url: "/api/oj/tch/get/oj/problem/list/for/problemlist/add/problem",
    params,
    method: "get",
  });
}
//教师给题单添加问题
export function tchAddProblemForProblemList(params) {
  return request({
    url: "/api/oj/tch/add/problem/for/problemlist",
    data: qs.stringify(params),
    method: "post",
  });
}
//获得题单题目列表
export function getProblemForProblemList(params) {
  return request({
    url: "/api/oj/get/problem/for/peoblemlist",
    params,
    method: "get",
  });
}

//教师给题单删除问题
export function tchDeleteProblemForProblemList(params) {
  return request({
    url: "/api/oj/tch/delete/problem/for/problemlist",
    data: qs.stringify(params),
    method: "post",
  });
}
//获得题目信息
export function getOjProblemInfoById(params) {
  return request({
    url: "/api/oj/get/oj/problem/info/by/id",
    params,
    method: "get",
  });
}


//教师添加或更新比赛
export function tchAddOrUpdateOjContest(params) {
  return request({
    url: "/api/oj/tch/add/or/update/oj/contest",
    data: qs.stringify(params),
    method: "post",
  });
}
//获得学校比赛列表
export function getSchoolOjContestList(params) {
  return request({
    url: "/api/oj/get/school/oj/contest/list",
    params,
    method: "get",
  });
}
//教师删除比赛
export function tchDeleteOjContest(params) {
  return request({
    url: "/api/oj/tch/delete/oj/contest",
    data: qs.stringify(params),
    method: "post",
  });
}
//教师给题单添加问题页面获得题目列表,去除了题单已包含的题目
export function tchGetOjProblemListForContest(params) {
  return request({
    url: "/api/oj/tch/get/oj/problem/list/for/contest/add/problem",
    params,
    method: "get",
  });
}
//获得比赛题目列表
export function getProblemForContest(params) {
  return request({
    url: "/api/oj/get/problem/for/contest",
    params,
    method: "get",
    // noLoading: true
  });
}
//教师添加问题
export function tchAddProblemForContest(params) {
  return request({
    url: "/api/oj/tch/add/problem/for/contest",
    data: qs.stringify(params),
    method: "post",
  });
}
//教师给比赛删除问题
export function tchDeleteProblemForContest(params) {
  return request({
    url: "/api/oj/tch/delete/problem/for/contest",
    data: qs.stringify(params),
    method: "post",
  });
}
//教师更新题目公开状态
export function tchUpdateOjProblemPublic(params) {
  return request({
    url: "/api/oj/tch/update/oj/problem/public",
    data: qs.stringify(params),
    method: "post",
  });
}
//教师获得自己创建的比赛列表
export function tchGetOwnOjContestList(params) {
  return request({
    url: "/api/oj/tch/get/own/oj/contest/list",
    params,
    method: "get",
  });
}
//教师比赛添加用户页面获得学生列表
export function tchGetStuListForAddContestUser(params) {
  return request({
    url: "/api/oj/tch/get/stu/list/for/add/contest/user",
    params,
    method: "get",
  });
}
//教师比赛添加用户页面获得用户列表
export function tchGetUserListForAddContestUser(params) {
  return request({
    url: "/api/oj/tch/get/user/list/for/add/contest/user",
    params,
    method: "get",
  });
}
//教师为比赛添加用户接口
export function tchAddContestSign(params) {
  return request({
    url: "/api/oj/tch/add/contest/sign",
    data: qs.stringify(params),
    method: "post",
  });
}
//教师获得比赛用户列表
export function tchGetOjContestSignList(params) {
  return request({
    url: "/api/oj/tch/get/oj/contest/sign/list",
    params,
    method: "get",
  });
}
//教师更新比赛用户审核状态接口
export function tchUpdateContestSignCheckState(params) {
  return request({
    url: "/api/oj/tch/update/contest/sign/check/state",
    data: qs.stringify(params),
    method: "post",
  });
}
//教师移除比赛用户报名信息接口
export function tchDeleteContestSign(params) {
  return request({
    url: "/api/oj/tch/delete/contest/sign",
    data: qs.stringify(params),
    method: "post",
  });
}
//获得本人比赛报名信息
export function getOjContestSignInfo(params) {
  return request({
    url: "/api/oj/get/oj/contest/sign/info",
    params,
    method: "get",
  });
}
//用户报名oj比赛接口
export function addUserContestSign(params) {
  return request({
    url: "/api/oj/add/user/contest/sign",
    data: qs.stringify(params),
    method: "post",
  });
}
//教师添加或更新团队
export function tchAddOrUpdateOjTeam(params) {
  return request({
    url: "/api/oj/tch/add/or/update/oj/team",
    data: qs.stringify(params),
    method: "post",
  });
}
//教师端获得自己创建的团队列表
export function tchGetOwnOjTeamList(params) {
  return request({
    url: "/api/oj/tch/get/own/oj/team/list",
    params,
    method: "get",
  });
}
//教师删除团队
export function tchDeleteOjTeam(params) {
  return request({
    url: "/api/oj/tch/delete/oj/team",
    data: qs.stringify(params),
    method: "post",
  });
}
//教师给团队添加题目，获得题目列表
export function tchGetOjProblemListForTeamAddProblem(params) {
  return request({
    url: "/api/oj/tch/get/oj/problem/list/for/team/add/problem",
    params,
    method: "get",
  });
}
//教师给团队添加问题
export function tchAddProblemForTeam(params) {
  return request({
    url: "/api/oj/tch/add/problem/for/team",
    data: qs.stringify(params),
    method: "post",
  });
}
//教师获得团队题目列表
export function tchGetProblemForTeam(params) {
  return request({
    url: "/api/oj/tch/get/problem/for/team",
    params,
    method: "get",
  });
}
//教师给团队删除问题
export function tchDeleteProblemForTeam(params) {
  return request({
    url: "/api/oj/tch/delete/problem/for/team",
    data: qs.stringify(params),
    method: "post",
  });
}
//教师团队添加学生页面获得学生列表
export function tchGetStuListForAddTeamStu(params) {
  return request({
    url: "/api/oj/tch/get/stu/list/for/add/team/stu",
    params,
    method: "get",
  });
}
//教师为团队添加学生
export function tchAddTeamStu(params) {
  return request({
    url: "/api/oj/tch/add/team/stu",
    data: qs.stringify(params),
    method: "post",
  });
}
//教师获得团队学生列表
export function tchGetTeamStuList(params) {
  return request({
    url: "/api/oj/tch/get/team/stu/list",
    params,
    method: "get",
  });
}
//教师移除团队学生接口
export function tchDeleteTeamStu(params) {
  return request({
    url: "/api/oj/tch/delete/team/stu",
    data: qs.stringify(params),
    method: "post",
  });
}
//教师给团队添加题单，获得题单列表
export function tchGetOjProblemlistForTeamAddProblemlist(params) {
  return request({
    url: "/api/oj/tch/get/oj/problemlist/for/team/add/problemlist",
    params,
    method: "get",
  });
}
//教师给团队添加题单
export function tchAddProblemlistForTeam(params) {
  return request({
    url: "/api/oj/tch/add/problemlist/for/team",
    data: qs.stringify(params),
    method: "post",
  });
}
//获得教师团队题单列表
export function tchGetProblemListForTeam(params) {
  return request({
    url: "/api/oj/tch/get/problemlist/for/team",
    params,
    method: "get",
  });
}
//教师给团队删除题单
export function tchDeleteProblemListForTeam(params) {
  return request({
    url: "/api/oj/tch/delete/problemlist/for/team",
    data: qs.stringify(params),
    method: "post",
  });
}
//学生端获得自己参加的团队列表
export function stuGetOjTeamList(params) {
  return request({
    url: "/api/oj/stu/get/oj/team/list",
    params,
    method: "get",
  });
}
//学生端获得自己参加的团队列表
export function stuGetTeamStuList(params) {
  return request({
    url: "/api/oj/stu/get/team/stu/list",
    params,
    method: "get",
  });
}
//学生获得团队题目列表
export function stuGetProblemForTeam(params) {
  return request({
    url: "/api/oj/stu/get/problem/for/team",
    params,
    method: "get",
  });
}
// //学生获得团队题单列表
// export function stuGetProblemListForTeam(params) {
//   return request({
//     url: "/api/oj/stu/get/problemlist/for/team",
//     params,
//     method: "get",
//   });
// }
//学生获得团队题单列表 新
export function stuGetProblemListForTeam(params) {
  return request({
    url: "/api/oj/stu/getProblemListForTeamNew",
    params,
    method: "get",
  });
}
//创建oj提交接口
export function createSubmission(params) {
  return request({
    url: "/api/create/submission",
    data: qs.stringify(params),
    method: "post",
  });
}
//创建oj提交新接口
export function createSubmissionForTest(params) {
  return request({
    url: "/api/createSubmissionForTest",
    data: qs.stringify(params),
    method: "post",
  });
}
//获得提交记录信息
export function getOjSubmissionInfo(params) {
  return request({
    url: "/api/oj/get/submission/info",
    params,
    method: "get",
    noLoading: true
  });
}
//获得题目提交记录
export function getProblemOjSubmissionList(params) {
  return request({
    url: "/api/oj/get/problem/oj/submission/list",
    params,
    method: "get",
  });
}
//获得用户题目提交记录
export function getUserOjSubmissionList(params) {
  return request({
    url: "/api/oj/get/user/oj/submission/list",
    params,
    method: "get",
  });
}
//获得用户题目提交记录 - 赛考中心用
export function getUserTestOjSubmissionList(params) {
  return request({
    url: "/api/oj/getUserTestOjSubmissionList",
    params,
    method: "get",
  });
}
//获得用户题目提交记录 新
export function getOneUserOjSubmissionListForTeam(params) {
  return request({
    url: "/api/oj/getOneUserOjSubmissionListForTeam",
    params,
    method: "get",
  });
}
//spj编译接口
export function compileSpj(params) {
  return request({
    url: "/api/spj-compilation",
    data: qs.stringify(params),
    method: "post",
  });
}
//教师更新比赛题目排序号
export function tchUpdateContestProblemSortNum(params) {
  return request({
    url: "/api/oj/tch/update/contest/problem/sortnum",
    data: qs.stringify(params),
    method: "post",
  });
}
//获得比赛排名列表
export function getContestRankList(params) {
  return request({
    url: "/api/oj/get/contest/rank/list",
    params,
    method: "get",
    // noLoading: true
  });
}
//获得用户比赛排名信息
export function getUserContestRank(params) {
  return request({
    url: "/api/oj/get/user/contest/rank",
    params,
    method: "get",
  });
}
//教师添加或编辑题解
export function tchAddOrUpdateOjProblemAnalysis(params) {
  return request({
    url: "/api/tch/add/or/update/oj/problem/analysis",
    data: qs.stringify(params),
    method: "post",
    noLoading: true
  });
}
//教师获得题目题解列表
export function tchGetOjProblemAnalysisList(params) {
  return request({
    url: "/api/tch/get/oj/problem/analysis/list",
    params,
    method: "get",
    // noLoading: true
  });
}
//教师删除题解
export function tchDeleteOjProblemAnalysis(params) {
  return request({
    url: "/api/tch/delete/problem/analysis",
    data: qs.stringify(params),
    method: "post",
  });
}
//自由编译提交接口
export function createRunRecord(params) {
  return request({
    url: "/api/create/run-record",
    data: qs.stringify(params),
    method: "post",
  });
}
//获得自由编译信息
export function getOjRunRecordInfo(params) {
  return request({
    url: "/api/oj/get/run/record/info",
    params,
    method: "get",
    noLoading: true
  });
}
//获得学校看板主数据
export function getSchoolBoardMainData(params) {
  return request({
    url: "/api/get/school/board/main/data",
    params,
    method: "get",
  });
}
//获得学校销售线索数据
export function getSchoolBoardIntendedStudentUserData(params) {
  return request({
    url: "/api/get/school/board/intended/student/user/data",
    params,
    method: "get",
  });
}
//获得学校诺到访学员线索数据
export function getSchoolBoardComeIntendedStudentUser(params) {
  return request({
    url: "/api/get/school/board/come/intended/student/user/data",
    params,
    method: "get",
  });
}
//获得学校教师上课数据
export function getSchoolBoardTchPlanData(params) {
  return request({
    url: "/api/get/school/board/tch/plan/data",
    params,
    method: "get",
  });
}
//获得多个校区的教师列表
export function getTeacherListByCampusIds(params) {
  return request({
    url: "/api/get/teacher/list/bycampus/ids",
    params,
    method: "get",
  });
}
//获得学校学生作业情况
export function getSchoolBoardStuTchWorkList(params) {
  return request({
    url: "/api/get/school/board/stu/tch/work/list",
    params,
    method: "get",
  });
}
//学校看板查询通知列表
export function getTchNoticeListForSchoolBoard(params) {
  return request({
    url: "/api/get/tch/notice/list/for/school/board",
    params,
    method: "get",
  });
}
//一键已读
export function updateAllNoticeRead(params) {
  return request({
    url: "/api/update/updateAllNoticeRead",
    data: qs.stringify(params),
    method: "post",
  });
}
//教师给sc作品修改操作说明和简介
export function tchSaveTchWorkInfo(params) {
  return request({
    url: "/api/tch/save/tch/work/info",
    data: qs.stringify(params),
    method: "post",
  });
}
//教师端获得教师c++课程对应的题目列表
export function tchGetTchCppLessonOjProblemList(params) {
  return request({
    url: "/api/tch/get/tch/cpp/lesson/oj/problem/list",
    params,
    method: "get",
  });
}
//保存任务作品
export function saveCppTchWork(params) {
  return request({
    url: "/api/save/cpp/tch/work",
    data: qs.stringify(params),
    method: "post",
  });
}
//学生端获得学生本c++课程对应的题目列表
export function stuGetStuCppLessonOjProblemList(params) {
  return request({
    url: "/api/stu/get/stu/cpp/lesson/oj/problem/list",
    params,
    method: "get",
  });
}
//教师端获得学生本c++课程对应的题目列表
export function tchGetStuCppLessonOjProblemList(params) {
  return request({
    url: "/api/tch/get/stu/cpp/lesson/oj/problem/list",
    params,
    method: "get",
  });
}
//获得学生oj题目作答记录
export function tchGetStuOjSubmissionList(params) {
  return request({
    url: "/api/tch/get/stu/oj/submission/list",
    params,
    method: "get",
  });
}
//自由编译获得列表
export function recordList(params) {
  return request({
    url: "/api/oj/get/user/oj/run/record/list",
    params,
    method: "get",
  });
}
//更新教学计划oj解析权限
export function updateTeachingPlanOjAnalysisAuth(params) {
  return request({
    url: "/api/update/teaching/plan/oj/analysis/auth",
    data: qs.stringify(params),
    method: "post",
  });
}
//更更新教学计划社区权限
export function updateTeachingPlanZoneAuth(params) {
  return request({
    url: "/api/update/teaching/plan/zone/auth",
    data: qs.stringify(params),
    method: "post",
  });
}
//社区发现页获得作品列表
export function getZoneFindMoreWorkList(params) {
  return request({
    url: "/api/get/zoneShare/getZoonShareFindMoreWorkList",
    params,
    method: "get",
  });
}
//更新校区共享社区权限
export function updateSchoolZoonShareAuth(params) {
  return request({
    url: "/api/get/zoneShare/updateSchoolZoonShareAuth",
    data: qs.stringify(params),
    method: "post",
  });
}
//获得合同列表
export function tchGetContract(params) {
  return request({
    url: "/api/get/contract",
    params,
    method: "get",
  });
}

//动态获得chargpt token
export function getGhatGptToken(params) {
  return request({
    url: "/api/get/getGhatGptToken",
    params,
    method: "get",
    noLoading: true
  });
}

//前端获得编辑器提示
export function getEditorRemark(params) {
  return request({
    url: "/api/get/editorRemark",
    params,
    method: "get",
  });
}
//获取Weboffice凭证
export function generateWebofficeToken(params) {
  return request({
    url: "/api/get/aliyun/generateWebofficeToken",
    params,
    method: "get",

  });
}

//刷新Weboffice凭证
export function refreshWebofficeToken(params) {
  return request({
    url: "/api/get/aliyun/refreshWebofficeToken",
    params,
    method: "get",
    noLoading: true

  });
}
//获取教师账号列表
export function getSchoolUserLoginInfo(params) {
  return request({
    url: "/api/get/school/user/login/info",
    params,
    method: "get",

  });
}
//查询题库来源列表
export function getTestQuestionBankSourceListWithoutP(params) {
  return request({
    url: "/api/exam/getTestQuestionBankSourceListWithoutPage",
    params,
    method: "get",

  });
}
//查询题库来源列表
export function getProblemForProblemListSort(params) {
  return request({
    url: "/api/oj/get/problem/for/peoblemlist/sort",
    params,
    method: "get",

  });
}
//更新题单题目排序
export function tchUpdateProblemSortOfPorblemList(params) {
  return request({
    url: "/api/tch/updateProblemSortOfPorblemList",
    data: qs.stringify(params),
    method: "post",
  });
}
//获得团队汇总数据
export function tchGetTeamTotalData(params) {
  return request({
    url: "/api/oj/getTeamTotalData",
    params,
    method: "get",

  });
}
//获得题单题目列表
// export function getProblemForTeamProblemList(params) {
//   return request({
//     url: "/api/oj/get/problem/for/team/peoblemlist",
//     params,
//     method: "get",
//     noLoading: true

//   });
// }
//获得题单题目列表 新 教师用
export function getProblemForTeamProblemList(params) {
  return request({
    url: "/api/oj/getProblemForTeamProblemListForNew",
    params,
    method: "get",
    noLoading: true

  });
}
//获得题单题目列表 新 学生用
export function stuGetProblemOfTeamPMList(params) {
  return request({
    url: "/api/oj/stu/getProblemOfTeamPMList",
    params,
    method: "get",
    noLoading: true

  });
}
//获得团队学生的排名
export function tchGetTeamStuRank(params) {
  return request({
    url: "/api/oj/getTeamStuRank",
    params,
    method: "get",

  });
}
//获得学生对于团队题单的完成情况//获得团队学生的排名
export function tchGetProblemListForSearchStuSubmitIn(params) {
  return request({
    url: "/api/tch/getProblemListForSearchStuSubmitInfo",
    params,
    method: "get",

  });
}
//获得教师团队题单列表
export function tchGetProblemListForTeamSort(params) {
  return request({
    // url: "/api/oj/tch/get/problemlist/for/team",
    url: '/api/oj/tch/get/problemlist/for/team/sort',
    params,
    method: "get",

  });
}
//更新题单题目排序
export function tchUpdateProblemListSortOfTeam(params) {
  return request({
    url: "/api/tch/updateProblemListSortOfTeam",
    data: qs.stringify(params),
    method: "post",
  });
}
//获得某人某题的提交记录
export function getOneUserOjSubmissionList(params) {
  return request({
    url: "/api/oj/getOneUserOjSubmissionList",
    params,
    method: "get",

  });
}
//教师获得团队学生列表不分表
export function tchGetTeamStuListNoPage(params) {
  return request({
    url: "/api/oj/tch/get/team/stu/list/noPage",
    params,
    method: "get",

  });
}
//获得教师端对团队提交情况的统计结果
export function ojTchGetTeamSubmissiontTotal(params) {
  return request({
    url: "/api/oj/tch/getTeamSubmissiontTotal",
    params,
    method: "get",

  });
}
//获得学生端对团队提交情况的统计结果
export function ojStuGetTeamSubmissiont(params) {
  return request({
    url: "/api/oj/stu/getTeamSubmissiontTotal",
    params,
    method: "get",

  });
}
//教师团队学生页面获得题单题目列表和学生对于题目的完成情况
// export function ojTchGetStuProblemListAndSubmission(params) {
//   return request({
//     url: "/api/oj/tch/getStuProblemListAndSubmission",
//     params,
//     method: "get",

//   });
// }
//教师团队学生页面获得题单题目列表和学生对于题目的完成情况
export function ojTchGetStuProblemListAndSubmission(params) {
  return request({
    url: "/api/oj/tch/getStuProblemListAndSubmissionForNew",
    params,
    method: "get",

  });
}
//教师修改题单发布状态
export function tchUpdateOjProblemListPoststate(params) {
  return request({
    url: "/api/oj/tch/updateOjProblemListPoststate",
    data: qs.stringify(params),
    method: "post",
  });
}
//更新oj团队全部学生查看题解的权限
export function ojTchUpdateTeamAllStuOjAnalysisAuth(params) {
  return request({
    url: "/api/oj/tch/updateTeamAllStuOjAnalysisAuth",
    data: qs.stringify(params),
    method: "post",
  });
}
//更新oj团队单个学生查看题解的权限
export function ojTchUpdateTeamSingleStuOjAnalysisAuth(params) {
  return request({
    url: "/api/oj/tch/updateTeamSingleStuOjAnalysisAuth",
    data: qs.stringify(params),
    method: "post",
  });
}
//不分页查询题单类型列表
export function ojTchGetOjProblemListTypeListWithOutP(params) {
  return request({
    url: "/api/oj/tch/get/oj/problemlisttype/list/WithOutPage",
    params,
    method: "get",

  });
}
//添加商品
export function addOrUpdateXmGoods(params) {
  return request({
    url: "/api/xm/addOrUpdateXmGoods",
    data: qs.stringify(params),
    method: "post",
  });
}
//获得商品列表
export function getXmGoodsList(params) {
  return request({
    url: "/api/xm/getXmGoodsList",
    params,
    method: "get",
  });
}
//删除商品
export function deleteXmGoods(params) {
  return request({
    url: "/api/xm/deleteXmGoods",
    data: qs.stringify(params),
    method: "post",
  });
}
//报名续费页面获得商品列表
export function getXmGoodsListForAdBuyXmOrder(params) {
  return request({
    url: "/api/xm/getXmGoodsListForAdBuyXmOrder",
    params,
    method: "get",
  });
}
//创建报名/续费订单接口
export function addBuyXmOrder(params) {
  return request({
    url: "/api/xm/addBuyXmOrder",
    data: qs.stringify(params),
    method: "post",
  });
}
//获得可以退物品的物品列表
export function getCanDropThings(params) {
  return request({
    url: "/api/xm/getCanDropThings",
    params,
    method: "get",
  });
}
//获得可以退物品的物品列表
export function getCanDropThingsBuyInfo(params) {
  return request({
    url: "/api/xm/getCanDropThingsBuyInfo",
    params,
    method: "get",
  });
}
//创建退物品订单
export function addDropThingsXmOrder(params) {
  return request({
    url: "/api/xm/addDropThingsXmOrder",
    data: qs.stringify(params),
    method: "post",
  });
}
//获得订单列表
export function getXmOrderList(params) {
  return request({
    url: "/api/xm/getXmOrderList",
    params,
    method: "get",
  });
}
//获得订单列表
export function getXmOrderInfo(params) {
  return request({
    url: "/api/xm/getXmOrderInfo",
    params,
    method: "get",
  });
}
//更新对内备注
export function updateXmOrderInRemark(params) {
  return request({
    url: "/api/xm/updateXmOrderInRemark",
    data: qs.stringify(params),
    method: "post",
  });
}
//更新支付凭证
export function uploadXmOrderPayProofImg(params) {
  return request({
    url: "/api/xm/uploadXmOrderPayProofImg",
    data: qs.stringify(params),
    method: "post",
  });
}
//更新对外备注
export function updateXmOrderOutRemark(params) {
  return request({
    url: "/api/xm/updateXmOrderOutRemark",
    data: qs.stringify(params),
    method: "post",
  });
}
//更新业绩归属人
export function updateXmOrderBelongUser(params) {
  return request({
    url: "/api/xm/updateXmOrderBelongUser",
    data: qs.stringify(params),
    method: "post",
  });
}
//作废订单
export function disableXmOrder(params) {
  return request({
    url: "/api/xm/disableXmOrder",
    data: qs.stringify(params),
    method: "post",
  });
}
//获得学生购买的课程商品列表
export function getXmGoodsListForStuPage(params) {
  return request({
    url: "/api/xmedu/getXmGoodsListForStuPage",
    params,
    method: "get",
  });
}
//班级添加关联商品页面获得可成商品列表
export function getXmGoodsListForClassEdit(params) {
  return request({
    url: "/api/xmedu/getXmGoodsListForClassEdit",
    params,
    method: "get",
  });
}
//班级去除关联商品前，检查是否有学生还在以此商品作为扣费方式
export function checkReomveXmGoods(params) {
  return request({
    url: "/api/xmedu/checkReomveXmGoods",
    params,
    method: "get",
  });
}
//设置学生班级内的扣费课程
export function updateStuClassCostXmGoods(params) {
  return request({
    url: "/api/xmedu/updateStuClassCostXmGoods",
    data: qs.stringify(params),
    method: "post",
  });
}
//课时清零
export function cleanLessonHour(params) {
  return request({
    url: "/api/xmedu/cleanLessonHour",
    data: qs.stringify(params),
    method: "post",
  });
}
//根据学生id查询可退课列表
export function getCanDropLesson(params) {
  return request({
    url: "/api/xm/getCanDropLesson",
    params,
    method: "get",
  });
}
// 获得退出课程列表购买信息
export function getCanDropLessonBuyInfo(params) {
  return request({
    url: "/api/xm/getCanDropLessonBuyInfo",
    params,
    method: "get",
  });
}
//创建退课程订单
export function addDropLessonXmOrder(params) {
  return request({
    url: "/api/xm/addDropLessonXmOrder",
    data: qs.stringify(params),
    method: "post",
  });
}
//转课接口
export function addTransferLessonXmOrder(params) {
  return request({
    url: "/api/xm/addTransferLessonXmOrder",
    data: qs.stringify(params),
    method: "post",
  });
}
//创建充值账户
export function addXmAccount(params) {
  return request({
    url: "/api/xm/addXmAccount",
    data: qs.stringify(params),
    method: "post",
  });
}
// 通过用户账号获得充值账户信息
export function getXmAccountInfoByAccountNo(params) {
  return request({
    url: "/api/xm/getXmAccountInfoByAccountNo",
    params,
    method: "get",
    noLoading: true

  });
}
// 通过学生id获得充值账户信息
export function getXmAccountInfoByStuId(params) {
  return request({
    url: "/api/xm/getXmAccountInfoByStuId",
    params,
    method: "get",
    noLoading: true
  });
}
//创建充值账户和学生关联
export function addXmAccountStu(params) {
  return request({
    url: "/api/xm/addXmAccountStu",
    data: qs.stringify(params),
    method: "post",
  });
}
//创建账户充值订单
export function addAccountRechargeOrder(params) {
  return request({
    url: "/api/xm/addAccountRechargeOrder",
    data: qs.stringify(params),
    method: "post",
  });
}
// 获得充值账户列表
export function getXmAccountList(params) {
  return request({
    url: "/api/xm/getXmAccountList",
    params,
    method: "get",
  });
}
//创建账户退款订单
export function addAccountRefundOrder(params) {
  return request({
    url: "/api/xm/addAccountRefundOrder",
    data: qs.stringify(params),
    method: "post",
  });
}
// 获得账户变动列表
export function getXmAccountRecordList(params) {
  return request({
    url: "/api/xm/getXmAccountRecordList",
    params,
    method: "get",
  });
}
//获得订单明细列表
export function getXmOrderGoodsList(params) {
  return request({
    url: "/api/xm/getXmOrderGoodsList",
    params,
    method: "get",
  });
}
//获得补交订单的商品列表
export function getXmOrderGoodsListForPayBack(params) {
  return request({
    url: "/api/xm/getXmOrderGoodsListForPayBack",
    params,
    method: "get",
  });
}
//补交接口
export function xmPayBack(params) {
  return request({
    url: "/api/xm/xmPayBack",
    data: qs.stringify(params),
    method: "post",
  });
}
//获得学生课消详情
export function getStuXmLessonHourRecord(params) {
  return request({
    url: "/api/xmedu/getStuXmLessonHourRecord",
    params,
    method: "get",
  });
}
//获得学生课时修正记录
export function getStuXmLessonHourRecordOfRevise(params) {
  return request({
    url: "/api/xmedu/getStuXmLessonHourRecordOfRevise",
    params,
    method: "get",
  });
}
//获得按课时扣费班级添加学生时的学生列表
export function getStuListForAddStuToClass(params) {
  return request({
    url: "/api/xmedu/getStuListForAddStuToClass",
    params,
    method: "get",
  });
}
//获得学生详情页面学生的上课记录
export function getStuClassRecordForXmStuInfoPage(params) {
  return request({
    url: "/api/xmedu/getStuClassRecordForXmStuInfoPage",
    params,
    method: "get",
  });
}
//无需补扣
export function noNeedCostLessonHour(params) {
  return request({
    url: "/api/xmedu/noNeedCostLessonHour",
    data: qs.stringify(params),
    method: "post",
  });
}
//补扣学时
export function makeUpLessonHour(params) {
  return request({
    url: "/api/xmedu/makeUpLessonHour",
    data: qs.stringify(params),
    method: "post",
  });
}
//作废课程订单时获得已签到的教学计划
export function getSignedStuTchPlanForDisableXmOrder(params) {
  return request({
    url: "/api/xm/getSignedStuTchPlanForDisableXmOrder",
    params,
    method: "get",
  });
}
//删除学生教学计划签到信息
export function deleteStuTchPlanSignInfo(params) {
  return request({
    url: "/api/delete/stuTchPlanSignInfo",
    data: qs.stringify(params),
    method: "post",
  });
}
//获得学生详情页面学生的信息
export function getStuInfoByStuId(params) {
  return request({
    url: "/api/xmedu/getStuInfoByStuId",
    params,
    method: "get",
  });
}
//标记已补
export function signMissLesson(params) {
  return request({
    url: "/api/xmedu/signMissLesson",
    data: qs.stringify(params),
    method: "post",
  });
}
//获得开班补课缺课学院按商品的统
export function getXmGoodsListForOpenClassOfMiss(params) {
  return request({
    url: "/api/xmedu/getXmGoodsListForOpenClassOfMiss",
    params,
    method: "get",
  });
}
//补课获得科目列表
export function getSubjectListForOpenClassOfMiss(params) {
  return request({
    url: "/api/xmedu/getSubjectListForOpenClassOfMiss",
    params,
    method: "get",
  });
}
//补课获得科目列表
export function getCurriculumtListForOpenClassOfMiss(params) {
  return request({
    url: "/api/xmedu/getCurriculumtListForOpenClassOfMiss",
    params,
    method: "get",
  });
}
//补课获得科目列表
export function getLessonListForOpenClassOfMiss(params) {
  return request({
    url: "/api/xmedu/getLessonListForOpenClassOfMiss",
    params,
    method: "get",
  });
}
//补课获得学生缺课记录
export function getStuAbsenceRcordForMiss(params) {
  return request({
    url: "/api/xmedu/getStuAbsenceRcordForMiss",
    params,
    method: "get",
  });
}
//补课获得学生缺课记录
export function getTeachingPlanListForJoinClassOfMiss(params) {
  return request({
    url: "/api/xmedu/getTeachingPlanListForJoinClassOfMiss",
    params,
    method: "get",
  });
}
//标记已补
export function addStuToTeachingPlanForJoinClassOfMiss(params) {
  return request({
    url: "/api/xmedu/addStuToTeachingPlanForJoinClassOfMiss",
    data: qs.stringify(params),
    method: "post",
  });
}
//取消补课
export function deleteStuFromTeachingPlanForJoinClass(params) {
  return request({
    url: "/api/xmedu/deleteStuFromTeachingPlanForJoinClassOfMiss",
    data: qs.stringify(params),
    method: "post",
  });
}
//获得补课详情
export function getStuFromTeachingPlanMissInfo(params) {
  return request({
    url: "/api/xmedu/getStuFromTeachingPlanMissInfo",
    params,
    method: "get",
  });
}
//开班补课
export function createClassAndTchPlanForOpenClassOfMi(params) {
  return request({
    url: "/api/xmedu/createClassAndTchPlanForOpenClassOfMiss",
    data: qs.stringify(params),
    method: "post",
  });
}
//获得学校补课班
export function getSchoolOpenMissClass(params) {
  return request({
    url: "/api/tch/xmedu/getSchoolOpenMissClass",
    params,
    method: "get",
  });
}
//获得补课班老师的教学计划
export function getSchoolOpenMissClassOfTeachingPlan(params) {
  return request({
    url: "/api/tch/xmedu/getSchoolOpenMissClassOfTeachingPlan",
    params,
    method: "get",
  });
}
//获得按课时扣费教学计划添加学生时的学生列表
export function getStuListForAddStuToTchPlan(params) {
  return request({
    url: "/api/xmedu/getStuListForAddStuToTchPlan",
    params,
    method: "get",
  });
}
//获得课消记录
export function getXmLessonHourRecord(params) {
  return request({
    url: "/api/xm/getXmLessonHourRecord",
    params,
    method: "get",
  });
}
//获得课消记录详情
export function getXmLessonHourRecordDetail(params) {
  return request({
    url: "/api/xm/getXmLessonHourRecordDetail",
    params,
    method: "get",
  });
}
//获得课消详情班级列表接口
export function getXmGoodsListForgetXmLessonHourRecor(params) {
  return request({
    url: "/api/xm/getClassListForGetXmLessonHourRecord",
    params,
    method: "get",
  });
}
//获得课消详情班级列表接口
export function getXmGoodsListForgetXmLesson(params) {
  return request({
    url: "/api/xm/getXmGoodsListForgetXmLessonHourRecord",
    params,
    method: "get",
  });
}
//获得付款记录
export function getXmOrderPayRecordList(params) {
  return request({
    url: "/api/xm/getXmOrderPayRecordList",
    params,
    method: "get",
  });
}
//财务页面获得学生的一些财务信息
export function getStuInfoForFinacialPages(params) {
  return request({
    url: "/api/xm/getStuInfoForFinacialPages",
    params,
    method: "get",
  });
}

//批量添加校区课程授权
export function bulkAddCampusCurriculumAuth(params) {
  return request({
    url: "/api/bulkAddCampusCurriculumAuth",
    data: qs.stringify(params),
    method: "post",
  });
}
//复制班级和创建教学计划
export function copyClassAndTchPlan(params) {
  return request({
    url: "/api/copyClassAndTchPlan",
    data: qs.stringify(params),
    method: "post",
  });
}
//复制班级和创建教学计划
export function copyTchPlanToClass(params) {
  return request({
    url: "/api/copyTchPlanToClass",
    data: qs.stringify(params),
    method: "post",
  });
}
//获得学员报读课程列表
export function getAllStuXmGoodsList(params) {
  return request({
    url: "/api/xmedu/getAllStuXmGoodsList",
    params,
    method: "get",
  });
}
//学生上课记录页面获得班级列表
export function getStuClassListForStuLessonRecordPage(params) {
  return request({
    url: "/api/xmedu/getStuClassListForStuLessonRecordPage",
    params,
    method: "get",
  });
}
//获得校区科目列表
export function getCampusArrSubjectList(params) {
  return request({
    url: "/api/get/campus/arr/subject/list",
    params,
    method: "get",
  });
}
//查看学生练习
export function ojTchGetStuSubmission(params) {
  return request({
    url: "/api/oj/tch/ojTchGetStuSubmission",
    params,
    method: "get",
  });
}
//更新团队助教
export function updateOjTeamAssistant(params) {
  return request({
    url: "/api/oj/tch/updateOjTeamAssistant",
    data: qs.stringify(params),
    method: "post",
  });
}
//获得团队助教列表
export function ojTchGetTeamAssistant(params) {
  return request({
    url: "/api/oj/tch/ojTchGetTeamAssistant",
    params,
    method: "get",
  });
}
//删除团队助教
export function ojTchDeleteTeamAssistant(params) {
  return request({
    url: "/api/oj/ojTchDeleteTeamAssistant",
    data: qs.stringify(params),
    method: "post",
  });
}
//获得oj总排名
export function ojGetTotalRank(params) {
  return request({
    url: "/api/oj/ojGetTotalRank",
    params,
    method: "get",
  });
}

//获得测试用例下载次数
export function getTestcaseDownloadNum(params) {
  return request({
    url: "/api/oj/getTestcaseDownloadNum",
    params,
    method: "get",
  });
}
//获得测试用例下载次数
export function getTestcaseViewNum(params) {
  return request({
    url: "/api/oj/getTestcaseViewNum",
    params,
    method: "get",
  });
}

//教师课程评价页面获得教学计划列表
export function getTchPlanListForEvaluate(params) {
  return request({
    url: "/api/tch/getTchPlanListForEvaluate",
    params,
    method: "get",
  });
}
// 获得该学生的课程点评列表
export function getEvaluateForStu(params) {
  return request({
    url: "/api/stu/getEvaluateForStu",
    params,
    method: "get",
  });
}
//教师课程评价页面获得教学计划包含的学生教学计划列表
export function getStuTchPlanListForEvaluate(params) {
  return request({
    url: "/api/tch/getStuTchPlanListForEvaluate",
    params,
    method: "get",
  });
}
//添加或更新评价
export function createOrUpdateStuTchPlanEvaluate(params) {
  return request({
    url: "/api/tch/createOrUpdateStuTchPlanEvaluate",
    data: qs.stringify(params),
    method: "post",
  });
}
//获得学生教学计划评价列表
export function getStuTchPlanEvaluateList(params) {
  return request({
    url: "/api/tch/getStuTchPlanEvaluateList",
    params,
    method: "get",
  });
}
//删除评价
export function deleteStuTchPlanEvaluate(params) {
  return request({
    url: "/api/tch/deleteStuTchPlanEvaluate",
    data: qs.stringify(params),
    method: "post",
  });
}
//h5页面获得课程评价详情
export function getStuTchPlanEvaluateForH5(params) {
  return request({
    url: "/api/h5/getStuTchPlanEvaluateForH5",
    params,
    method: "get",
  });
}
//发送课程点评模板消息
export function sendStuTchPlanEvaluateTemplateMessage(params) {
  return request({
    url: "/api/wechat/sendStuTchPlanEvaluateTemplateMessage",
    data: qs.stringify(params),
    method: "post",
  });
}
//h5页面获得课程评价详情
export function getJSSDKSign(params) {
  return request({
    url: "/api/wechat/get/JSSDK/sign",
    params,
    method: "get",
  });
}
//通过学生教学计划id获得学生课堂任务作品和课后作业作品列表
export function getTchWorkOfStuTchPlan(params) {
  return request({
    url: "/api/tch/getTchWorkOfStuTchPlan",
    params,
    method: "get",
  });
}
//学生端获得课程信息
export function getLessonInfoForStuSys(params) {
  return request({
    url: "/api/stu/getLessonInfoForStuSys",
    params,
    method: "get",
  });
}

//校长查看教师点评
export function getTchPlanListForEvaluateOfHead(params) {
  return request({
    url: "/api/get/tchPlanListForEvaluateOfHead",
    params,
    method: "get",
  });
}
//教师更新比赛报名状态
export function tchUpdateOjContestPostState(params) {
  return request({
    url: "/api/oj/tch/updateOjContestPostState",
    data: qs.stringify(params),
    method: "post",
    noLoading: true

  });
}
//校长查看教师点评
export function getUserAllOjSubmissionList(params) {
  return request({
    url: "/api/oj/get/user/all/oj/submission/list",
    params,
    method: "get",
  });
}
//教师更新比赛报名状态
export function tchUpdateOjContestSignState(params) {
  return request({
    url: "/api/oj/tch/updateOjContestSignState",
    data: qs.stringify(params),
    method: "post",
    noLoading: true

  });
}
//检查学生绑定微信小程序家长号的情况
export function checkStuParentRelation(params) {
  return request({
    url: "/api/checkStuParentRelation",
    params,
    method: "get",
  });
}
//更新充值账户
export function updateXmAccount(params) {
  return request({
    url: "/api/xm/updateXmAccount",
    data: qs.stringify(params),
    method: "post",
    noLoading: true

  });
}
//更新班级上课星期字段
export function updateClassWeekJson(params) {
  return request({
    url: "/api/updateClassWeekJson",
    data: qs.stringify(params),
    method: "post",
    noLoading: true

  });
}
//查询充值账户和学生关联
export function getXmAccountStuList(params) {
  return request({
    url: "/api/xm/getXmAccountStuList",
    params,
    method: "get",
  });
}
//删除账户和学生绑定关系
export function delXmAccountStu(params) {
  return request({
    url: "/api/xm/delXmAccountStu",
    data: qs.stringify(params),
    method: "post",
    noLoading: true

  });
}
//获得未读消息
export function getTchRecentNotReadNotice(params) {
  return request({
    url: "/api/getTchRecentNotReadNotice",
    params,
    method: "get",
  });
}
//更新学生平台权限
export function updateStudentAuth(params) {
  return request({
    url: "/api/updateStudentAuth",
    data: qs.stringify(params),
    method: "post",
    noLoading: true
  });
}
//获得自定义header设置
export function getHeaderSet(params) {
  return request({
    url: "/api/getHeaderSet",
    params,
    method: "get",
  });
}
//更新自定义header设置
export function updateHeaderSet(params) {
  return request({
    url: "/api/updateHeaderSet",
    data: qs.stringify(params),
    method: "post",
    noLoading: true
  });
}
//获得班级信息，附带班级前四条教学计划信息
export function getTchIndexClassListWithTchPlanInfo(params) {
  return request({
    url: "/api/tch/getTchIndexClassListWithTchPlanInfo",
    params,
    method: "get",
  });
}
//日历
export function tchGetTeachingPlanList(params) {
  return request({
    url: "/api/tch/getTeachingPlanList",
    params,
    method: "get",
  });
}
//更新信奥专区学校排名方式
export function api_updateSchoolOjRankTotalAuth(params) {
  return request({
    url: "/api/updateSchoolOjRankTotalAuth",
    data: qs.stringify(params),
    method: "post",
    noLoading: true
  });
}
//更新备课中心课程说明
export function api_updateSchoolPrepareContentAuth(params) {
  return request({
    url: "/api/updateSchoolPrepareContentAuth",
    data: qs.stringify(params),
    method: "post",
    noLoading: true
  });
}
//学生端获得教学计划信息

export function getTchPlanInfoByStuTchPlanId(params) {
  return request({
    url: "/api/stu/getTchPlanInfoByStuTchPlanId",
    params,
    method: "get",
  });
}
//更新教学计划py编辑器自动补全权限
export function updateTeachingPlanEditorShowhintAuth(params) {
  return request({
    url: "/api/updateTeachingPlanEditorShowhintAuth",
    data: qs.stringify(params),
    method: "post",
    noLoading: true
  });
}
//更新oj比赛全部学生查看测试用例的权限
export function ojTchUpdateContestAllStuOjTestcaseAuth(params) {
  return request({
    url: "/api/oj/tch/ojTchUpdateContestAllStuOjTestcaseAuth",
    data: qs.stringify(params),
    method: "post",
    noLoading: true
  });
}
//更新oj比赛单个学生查看测试用例的权限
export function ojTchUpdateTeamSingleStuOjTestcaseAuth(params) {
  return request({
    url: "/api/oj/tch/ojTchUpdateTeamSingleStuOjTestcaseAuth",
    data: qs.stringify(params),
    method: "post",
    noLoading: true
  });
}
//获得学生练习提交次数
export function stuexamGetExamStuSubmitTimes(params) {
  return request({
    url: "/api/stuexam/getExamStuSubmitTimes",
    params,
    method: "get",
    noLoading: true
  });
}


/**
 * 收藏或取消收藏试卷
 * @param paperId 试卷id
 * @param operate 1收藏 2取消收藏
 * @returns 
 */
export function operateKeepPaper(params) {
  return request({
    url: "/api/exam/operateKeepPaper",
    data: qs.stringify(params),
    method: "post",
    noLoading: true
  });
}
/**
 * 获取收藏的试卷
 * @param title 标题
 * @param subject_id 科目
 * @param page_no
 * @param page_size
 * @returns 
 */
export function getKeepPaperList(params) {
  return request({
    url: "/api/exam/getKeepPaperList",
    params,
    method: "get",
  });
}
/**
 * 教师端新的 练习的试卷预览功能
 * @param examId 练习id
 * @returns 
 */
export function getQuestionListPractice(params) {
  return request({
    url: "/api/exam/get/question/list/practice",
    params,
    method: "get",
  });
}

/**
 * 给学生购买的课程打标记
 * @param stuId 学生id
 * @param xm_goods_id 商品id
 * @param status 状态 1未完结 2已完结
 * @returns 
 */
export function updateStuXmGoodsStatus(params) {
  return request({
    url: "/api/xmedu/updateStuXmGoodsStatus",
    data: qs.stringify(params),
    method: "post",
    noLoading: true
  });
}

/**
 * 学生端获得用户二维码
 * @param examId 练习id
 * @returns 
 */
export function getQrCodeForStu(params) {
  return request({
    url: "/api/wechat/get/qr/code/for/stu",
    params,
    method: "get",
  });
}

/**
 * 赛考中心试卷收藏-拷贝试卷
 * @param paper_id: 试卷ID,
 * @param paper_title: 试卷名称,
 * @returns 
 */
export function examCopyPaper(params) {
  return request({
    url: "/api/exam/copy/paper/and/keep",
    data: qs.stringify(params),
    method: "post",
  });
}
/**
 * 赛考中心试卷收藏-新增试卷
 * @param subject_id: this.form_bank.subject_id,
   @param paper_title: this.papername,
   @param questionBankIds: JSON.stringify(this.questionBankIds),
   @param questionArr: JSON.stringify(this.questionArr),
 * @returns 
 */
export function examAddPaper(params) {
  return request({
    url: "/api/exam/add/paper/and/keep",
    data: qs.stringify(params),
    method: "post",
  });
}
/**
 * 赛考中心试卷收藏-修改试卷名称
 * @param id: 试卷ID,
   @param title: 试卷名称,
 * @returns 
 */
export function editPaperTitle(params) {
  return request({
    url: "/api/exam/editPaperTitle",
    data: qs.stringify(params),
    method: "post",
  });
}
